import React, { Component } from "react";
import styled from "styled-components";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Checkbox } from 'pretty-checkbox-react';
import { withTranslation, Trans } from 'react-i18next';
// import BlocFeedsforparent from  "../children/home/components/bloc-feed-parent";
import queryString from 'query-string';
import Modal from 'react-responsive-modal'
import {Button} from 'react-bootstrap'
import IntlTelInput from 'components/IntlTelInputWrapper';
import 'react-intl-tel-input/dist/main.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MediaQuery from "react-responsive";
// import LoadingAssets from '../../../components/LoadingAssets';
import {unconnected_api_post} from "services/cms/api";
import {format_s3_file_name} from 'utils/utils';
import { installMetaPixel, installGoogleTag, installMicrosoftClarity } from "utils/utils";
import {upload_asset_s3_api} from 'services/cms/api';
import { images } from "../../school/_resources";
import moment from "moment";
import {PhoneNumberFormat, PhoneNumberUtil} from 'google-libphonenumber';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import RadioEl from '../../school/professors/components/RadioEl';
import purple from "@material-ui/core/colors/purple";
import fr from 'date-fns/locale/fr';
registerLocale('fr', fr)
const phoneUtil = PhoneNumberUtil.getInstance();

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: { main: purple[500] }, // Purple and green play nicely together.
    secondary: { main: "#00b3a9" } // This is just green.A700 as hex.
  }
});
const emailRegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
class DashboardSchoolClientInscription extends Component {
  constructor(props) {
    super(props);
    this.params = new URLSearchParams(window.location.search);
    this.state = {
      target_school_style: props.global_data.target_school_style,
      selected_scholar_year: props.global_data.current_scholar_year,
      next_scholar_year: props.global_data.next_scholar_year,
      school_target: props.global_data.school_target,
      all_schools_targets: props.global_data.all_schools_targets,
      school_id_target: props.global_data.school_id_target,
      children_data: [{key: parseInt(Math.random() * 100000)}],
      errors: {},
      bulletin_uploading: false,
      responsable_full_name: "",
      responsable_phone: "",
      responsable_email: "",
      succession_message: window.location.pathname.indexOf("inscription-madina-schools-merci/") > -1 ? "Votre demande a été enregistrée" : "",
    };
    this.inscription_format = ((props.global_data.school_target || {}).unconnected_inscription_configuration || {}).format || "format_1";
    this.save_names_in_uppercase_in_preinscription = props.global_data.school_target && props.global_data.school_target.save_names_in_uppercase_in_preinscription || false;
  }

  componentWillReceiveProps(props) {
    if(props.global_data.school_target != this.state.school_target || props.global_data.target_school_style != this.state.target_school_style){
      this.setState({
        target_school_style: props.global_data.target_school_style,
        selected_scholar_year: props.global_data.current_scholar_year,
        next_scholar_year: props.global_data.next_scholar_year,
        school_target: props.global_data.school_target,
        all_schools_targets: props.global_data.all_schools_targets,
        school_id_target: props.global_data.school_id_target,
      });
      this.inscription_format = ((props.global_data.school_target || {}).unconnected_inscription_configuration || {}).format || "format_1";
      this.save_names_in_uppercase_in_preinscription = props.global_data.school_target &&  props.global_data.school_target.save_names_in_uppercase_in_preinscription;
    }
  };
  componentDidMount() {
  }



  transformText = (to_uppercase, text, trim) => {
    text = text || "";
    if(to_uppercase){
      text = (text || "").toUpperCase();
    }
    if(trim){
      text = text.trim();
    }
    return text;
  }

  componentWillUnmount() {
  }
  handleBrowseFiles = (evt, child_index) => {
    child_index = child_index || 0;
    var files = evt.target.files;
    var {children_data, bulletin_uploading} = this.state;
    var child_data = children_data[child_index];
    var new_state = {};
    this.files_to_upload = files.length;
    for(var i = 0; i < files.length; i++) {
      let formData = new FormData(),
      file = files[i];
      formData.append("file", file, "unconnected_user" + '_' + (new Date()).getTime() + '___' + file.name);
      formData.append("personal", true);
      child_data.bulletin_link = file.name;
      bulletin_uploading = true;
      upload_asset_s3_api(formData).then(res => {
        child_data.bulletin_link = res.url;
        children_data[child_index] = child_data;
        this.files_to_upload--;
        if(this.files_to_upload == 0){
          this.setState({
            bulletin_uploading: false,
            children_data: children_data
          });
        }
      }).catch(error => console.log("error", error));
    }
    new_state.bulletin_uploading = bulletin_uploading;
    children_data[child_index] = child_data;
    new_state.children_data = children_data;
    this.setState(new_state);
  }

  handleRemoveBulletin = (evt, confirmed, child_index) => {
    child_index = child_index || 0;
    if(evt){
      evt.stopPropagation();
    }
    if(confirmed){
      var {children_data} = this.state;
      children_data[child_index].bulletin_link = "";
      this.setState({
        children_data: children_data
      });
    }
    else{
      this.setState({
        open_confirmation: true,
      });
    }
  }
  render_header = school_target => {
    var unconnected_inscription_configuration = (school_target || {}).unconnected_inscription_configuration;
    return <div className="header" style={{backgroundColor: (unconnected_inscription_configuration.style || {}).header_bg || "#3eb6ad"}}>
      <div className="row">
        <div className="col col-md-12 col-12">
          <div className="logo">
            <img src={school_target.logo_url || school_target.logo2 || images.default_school_logo} />
          </div>
        </div>
        {(school_target.tel1 || school_target.tel2 || school_target.fax || school_target.email) &&
          <div className="col col-md-12 col-12 col-contact">
            <div className="row row2 contact_infos">
              <div className="col2 col-md-12 col-12">
                <div className="text">
                  <span className="text1">{"Contactez nous !"}</span>
                  <span className="text2">{"Pour toutes vos questions & demandes d'informations"}</span>
                </div>
              </div>
              <div className="col2 col-md-12 col-12">
                <div className="info_contacts">
                  {school_target.tel1 &&
                    <div className="contact_info">
                      <i className="fa fa-phone"></i><span>{school_target.tel1}</span>
                    </div>
                  }
                  {school_target.tel2 &&
                    <div className="contact_info">
                      <i className="fa fa-phone"></i><span>{school_target.tel2}</span>
                    </div>
                  }
                  {school_target.faxe &&
                    <div className="contact_info">
                      <i className="fa fa-phone"></i><span>{school_target.faxe}</span>
                    </div>
                  }
                  {school_target.email &&
                    <div className="contact_info">
                      <i className="fa fa-envelope"></i><span>{school_target.email}</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
  submit = () => {
    var {children_data, is_submitting, school_id_target, school_target, selected_scholar_year, next_scholar_year, target_school_style, responsable_full_name, responsable_phone, responsable_email} = this.state;
    if(is_submitting){
      return;
    }
    var unconnected_inscription_configuration = school_target.unconnected_inscription_configuration;
    var errors = {};
    var form_valid = true;
    let first_name = "";
    let last_name = "";
    if(target_school_style == 2){
      responsable_full_name = responsable_full_name.trim();
      if(responsable_full_name == ""){
        errors.responsable_full_name = "Ce champ est obligatoire!";
        form_valid = false;
      }
      else{
        responsable_full_name = responsable_full_name.replaceAll("  ", " ").replaceAll("  ", " ").replaceAll("  ", " ");
        let full_name_parts = responsable_full_name.split(" ");
        if(full_name_parts.length < 2){
          errors.responsable_full_name = "Veuillez entrer votre nom et prénom!";
          form_valid = false;
        }
        else if (full_name_parts.length > 2 && full_name_parts[0].toUpperCase() == "EL"){
          last_name = full_name_parts[0] + " " + full_name_parts[1];
          first_name = full_name_parts.slice(2).join(" ");
        }
        else{
          last_name = full_name_parts[0];
          first_name = full_name_parts.slice(1).join(" ");
        }
      }
      responsable_phone = responsable_phone.trim();
      if(responsable_phone == ""){
        errors.responsable_phone = "Ce champ est obligatoire!";
        form_valid = false;
      }
      else{
        responsable_phone = responsable_phone.replaceAll("  ", " ").replaceAll("  ", " ").replaceAll("  ", " ");
        let is_valid = true;
        try {is_valid = phoneUtil.isPossibleNumber(phoneUtil.parse(responsable_phone, "MA"));}catch (error){is_valid=false;}
        if(!is_valid){
          errors.responsable_phone = "Ce numéro est invalide!";
          form_valid = false;
        }
      }
      responsable_email = responsable_email.trim();
      if(responsable_email == ""){
        errors.responsable_email = "Ce champ est obligatoire!";
        form_valid = false;
      }
      else if(!emailRegExp.test(responsable_email)){
        errors.responsable_email = "Cet email est invalide!";
        form_valid = false;
      }
    }
    else{
    children_data.map(child_data => {
      errors[child_data.key] = {};
      if(!child_data.last_name && !child_data.last_name_ar){
        errors[child_data.key].last_name = "Ce champ est obligatoire!";
        form_valid = false;
      }
      if(!child_data.first_name && !child_data.first_name_ar){
        errors[child_data.key].first_name = "Ce champ est obligatoire!";
        form_valid = false;
      }
      if(["format_2", "format_3", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 && !child_data.birthday){
        errors[child_data.key].birthday = "Ce champ est obligatoire!";
        form_valid = false;
      }
      if(!child_data.level_id){
        errors[child_data.key].level = "Ce champ est obligatoire!";
        form_valid = false;
      }
      if(["format_2", "format_3", "format_4", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 && !child_data.responsable_last_name && !child_data.responsable_last_name_ar){
        errors[child_data.key].responsable_last_name = "Ce champ est obligatoire!";
        form_valid = false;
      }
      if(["format_2", "format_3", "format_4", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 && !child_data.responsable_first_name && !child_data.responsable_first_name_ar){
        errors[child_data.key].responsable_first_name = "Ce champ est obligatoire!";
        form_valid = false;
      }
      if(!child_data.gsm_1){
        errors[child_data.key].gsm_1 = "Ce champ est obligatoire!";
        form_valid = false;
      }
      else if(child_data.gsm_1 == child_data.gsm_2){
        errors[child_data.key].gsm_1 = "GSM1 et GSM2 ne doivent pas être identiques!";
        errors[child_data.key].gsm_2 = "GSM1 et GSM2 ne doivent pas être identiques!";
        form_valid = false;
      }
      else if(child_data.gsm_1_2 && child_data.gsm_1_2 == child_data.gsm_2){
        errors[child_data.key].gsm_1_2 = "GSM1(2) et GSM2 ne doivent pas être identiques!";
        errors[child_data.key].gsm_2 = "GSM1(2) et GSM2 ne doivent pas être identiques!";
        form_valid = false;
      }
      else if(child_data.gsm_1 && child_data.gsm_1 == child_data.gsm_1_2){
        errors[child_data.key].gsm_1 = "GSM1 et GSM1(2) ne doivent pas être identiques!";
        errors[child_data.key].gsm_1_2 = "GSM1 et GSM1(2) ne doivent pas être identiques!";
        form_valid = false;
      }
      else{
        var is_valid = true;
        try {is_valid = phoneUtil.isPossibleNumber(phoneUtil.parse(child_data.gsm_1));}catch (error){is_valid=false;}
        if(!is_valid){
          errors[child_data.key].gsm_1 = "Ce numéro est invalide!";
          form_valid = false;
        }
      }
      if(["format_5"].indexOf(this.inscription_format) !== -1 && !child_data.email){
        errors[child_data.key].email = "Ce champ est obligatoire!";
        form_valid = false;
      }
      if((child_data.responsable2_first_name || child_data.responsable2_first_name_ar || child_data.responsable2_last_name || child_data.responsable2_last_name_ar) && !child_data.gsm_2){
        errors[child_data.key].gsm_2 = "Ce champ est obligatoire!";
        form_valid = false;
      }
      else if(child_data.gsm_2){
        var is_valid2 = true;
        try {is_valid2 = phoneUtil.isPossibleNumber(phoneUtil.parse(child_data.gsm_2));}catch (error){is_valid2=false;}
        if(!is_valid2){
          errors[child_data.key].gsm_2 = "Ce numéro est invalide!";
          form_valid = false;
        }
      }
      if(child_data.email && !emailRegExp.test(child_data.email)){
        errors[child_data.key].email = "Cet email est invalide!";
        form_valid = false;
      }
      if(child_data.email2 && !emailRegExp.test(child_data.email2)){
        errors[child_data.key].email2 = "Cet email est invalide!";
        form_valid = false;
      }
      else if(child_data.email2 && emailRegExp.test(child_data.email2) && child_data.email && emailRegExp.test(child_data.email) && child_data.email2 == child_data.email){
        errors[child_data.key].email2 = "Les emails des deux parents ne doivent pas être identiques";
        errors[child_data.key].email = "Les emails des deux parents ne doivent pas être identiques";
        form_valid = false;
      }
      if(child_data.have_a_health_problem && !child_data.health_problem){
        errors[child_data.key].health_problem = "Ce champ est obligatoire!";
        form_valid = false;
      }
      if(child_data.emergency_contact == "o" && !(child_data.emergency_contact_phone)){
        errors[child_data.key].emergency_contact_phone = "Ce champ est obligatoire!";
        form_valid = false;
      }
    })
    }
    if(form_valid){
      this.setState({is_submitting: true, errors: errors});
      if(target_school_style == 2){
        let level_id_;
        let level_group_id_;
        if(school_target){
          school_target.levels_groups.map(lg => {
            level_group_id_ = level_group_id_ || lg.id;
            level_id_ = level_id_ || (lg.levels[0] || {}).level_id;
          });
        }
        var children_data_ = children_data.map(child_data => {
          return {
            last_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.last_name || "", true),
            first_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.first_name || "", true),
            responsable_last_name: this.transformText(this.save_names_in_uppercase_in_preinscription, last_name || "", true),
            responsable_first_name: this.transformText(this.save_names_in_uppercase_in_preinscription, first_name || "", true),
            responsable2_last_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable2_last_name || "", true),
            responsable2_first_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable2_first_name || "", true),
            last_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.last_name_ar || "", true),
            first_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.first_name_ar || "", true),
            responsable_last_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable_last_name_ar || "", true),
            responsable_first_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable_first_name_ar || "", true),
            responsable2_last_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable2_last_name_ar || "", true),
            responsable2_first_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable2_first_name_ar || "", true),
            level_id: level_id_,
            level_group_id: level_group_id_,
            gsm_1: responsable_phone || "",
            gsm_1_2: child_data.gsm_1_2 || "",
            gsm_2: child_data.gsm_2 || "",
            birthday1: child_data.birthday1 ? (moment(child_data.birthday1).format("YYYY-MM-DD")) : null,
            birthday2: child_data.birthday2 ? (moment(child_data.birthday2).format("YYYY-MM-DD")) : null,
            company1: child_data.company1 || "",
            company2: child_data.company2 || "",
            birthday: child_data.birthday || null,
            birth_place: child_data.birth_place || "",
            birth_place_ar: child_data.birth_place_ar || "",
            actual_school: child_data.actual_school || "",
            bulletin_link: child_data.bulletin_link || "",
            address: child_data.address,
            email: responsable_email || "",
            email2: child_data.email2 || "",
            blood_group: child_data.blood_group || "",
            child_doctor_address: child_data.child_doctor_address || "",
            child_doctor_first_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.child_doctor_first_name || "", true),
            child_doctor_last_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.child_doctor_last_name || "", true),
            child_doctor_phone: child_data.child_doctor_phone || "",
            child_lives_with: child_data.child_lives_with || "",
            first_language: child_data.first_language || "",
            second_language: child_data.second_language || "",
            other_languages: child_data.other_languages || "",
            special_diet: child_data.special_diet || "",
            emergency_contact: child_data.emergency_contact || "",
            emergency_contact_address: child_data.emergency_contact_address || "",
            emergency_contact_first_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.emergency_contact_first_name || "", true),
            emergency_contact_last_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.emergency_contact_last_name || "", true),
            emergency_contact_phone: child_data.emergency_contact_phone || "",
            insc_child_nationality: child_data.insc_child_nationality || "",
            last_classe_attended: child_data.last_classe_attended || "",
            redoublant: child_data.redoublant || false,
            gender: child_data.gender || "",
            have_a_health_problem: child_data.have_a_health_problem || false,
            health_problem: child_data.health_problem || "",
            parent_authorizes_child_to_participate_to_external_activities: child_data.parent_authorizes_child_to_participate_to_external_activities || false,
            parent_authorizes_school_take_student_photo: child_data.parent_authorizes_school_take_student_photo || false,
            parent_authorizes_school_to_broadcast_student_photo: child_data.parent_authorizes_school_to_broadcast_student_photo || false,
            nbr_brothers: child_data.nbr_brothers || 0,
            nbr_sisters: child_data.nbr_sisters || 0,
            position_in_brothers: child_data.position_in_brothers || 1,
            nationality1: child_data.nationality1 || "",
            nationality2: child_data.nationality2 || "",
            profession1: child_data.profession1 || "",
            profession2: child_data.profession2 || "",
            work_place1: child_data.work_place1 || "",
            work_place2: child_data.work_place2 || "",
            cin_father: child_data.cin_father || "",
            cin_mother: child_data.cin_mother || ""
          }
        })
      }
      else{
      var children_data_ = children_data.map(child_data => {
        return {
          last_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.last_name || "", true),
          first_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.first_name || "", true),
          responsable_last_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable_last_name || "", true),
          responsable_first_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable_first_name || "", true),
          responsable2_last_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable2_last_name || "", true),
          responsable2_first_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable2_first_name || "", true),
          last_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.last_name_ar || "", true),
          first_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.first_name_ar || "", true),
          responsable_last_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable_last_name_ar || "", true),
          responsable_first_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable_first_name_ar || "", true),
          responsable2_last_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable2_last_name_ar || "", true),
          responsable2_first_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.responsable2_first_name_ar || "", true),
          level_id: child_data.level_id,
          level_group_id: child_data.level_group_id,
          gsm_1: child_data.gsm_1,
          gsm_1_2: child_data.gsm_1_2 || "",
          gsm_2: child_data.gsm_2 || "",
          birthday1: child_data.birthday1 ? (moment(child_data.birthday1).format("YYYY-MM-DD")) : null,
          birthday2: child_data.birthday2 ? (moment(child_data.birthday2).format("YYYY-MM-DD")) : null,
          company1: child_data.company1 || "",
          company2: child_data.company2 || "",
          birthday: child_data.birthday || null,
          birth_place: child_data.birth_place || "",
          birth_place_ar: child_data.birth_place_ar || "",
          actual_school: child_data.actual_school || "",
          bulletin_link: child_data.bulletin_link || "",
          address: child_data.address,
          email: child_data.email,
          email2: child_data.email2 || "",
          blood_group: child_data.blood_group || "",
          child_doctor_address: child_data.child_doctor_address || "",
          child_doctor_first_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.child_doctor_first_name || "", true),
          child_doctor_last_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.child_doctor_last_name || "", true),
          child_doctor_phone: child_data.child_doctor_phone || "",
          child_lives_with: child_data.child_lives_with || "",
          first_language: child_data.first_language || "",
          second_language: child_data.second_language || "",
          other_languages: child_data.other_languages || "",
          special_diet: child_data.special_diet || "",
          emergency_contact: child_data.emergency_contact || "",
          emergency_contact_address: child_data.emergency_contact_address || "",
          emergency_contact_first_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.emergency_contact_first_name || "", true),
          emergency_contact_last_name: this.transformText(this.save_names_in_uppercase_in_preinscription, child_data.emergency_contact_last_name || "", true),
          emergency_contact_phone: child_data.emergency_contact_phone || "",
          insc_child_nationality: child_data.insc_child_nationality || "",
          last_classe_attended: child_data.last_classe_attended || "",
          redoublant: child_data.redoublant || false,
          gender: child_data.gender || "",
          have_a_health_problem: child_data.have_a_health_problem || false,
          health_problem: child_data.health_problem || "",
          parent_authorizes_child_to_participate_to_external_activities: child_data.parent_authorizes_child_to_participate_to_external_activities || false,
          parent_authorizes_school_take_student_photo: child_data.parent_authorizes_school_take_student_photo || false,
          parent_authorizes_school_to_broadcast_student_photo: child_data.parent_authorizes_school_to_broadcast_student_photo || false,
          nbr_brothers: child_data.nbr_brothers || 0,
          nbr_sisters: child_data.nbr_sisters || 0,
          position_in_brothers: child_data.position_in_brothers || 1,
          nationality1: child_data.nationality1 || "",
          nationality2: child_data.nationality2 || "",
          profession1: child_data.profession1 || "",
          profession2: child_data.profession2 || "",
          work_place1: child_data.work_place1 || "",
          work_place2: child_data.work_place2 || "",
          cin_father: child_data.cin_father || "",
          cin_mother: child_data.cin_mother || ""
        }
      })
      }
      var data = {
        action: "unconnected_inscription_create",
        children_data: children_data_,
        school_id: school_id_target,
        target_school_style: target_school_style,
        other_site_id: school_target.id,
        scholar_year_id: next_scholar_year ? next_scholar_year.id : selected_scholar_year.id,
        from_page: !this.params.get('from_page')?'koolskools':this.params.get('from_page'),
        ignore_sms: this.params.get('ignore_sms')?1:undefined
      };
      unconnected_api_post(data).then(res => {
        var new_state = {is_submitting: false};
        if(res.success){
          if(window.location.pathname.indexOf("inscription-madina-schools/") > -1){
            var current_search = window.location.search || "";
            var current_hash = window.location.hash || "";
            window.location.assign("/inscription-madina-schools-merci/" + current_search + current_hash);
            return;
          }
          new_state.succession_message = res.message;
          if(window !== window.top && window.parent.postMessage){
            const message = {
              type: 'callback_url',
              data: unconnected_inscription_configuration.callback_url
            };
            window.parent.postMessage(message, '*');
          }
          else
            if(unconnected_inscription_configuration.callback_url){
              setTimeout(() => {
                  document.location.href = unconnected_inscription_configuration.callback_url;
              }, 1000);
            }
        }
        this.setState(new_state);
      }).catch(err => {
        this.setState({is_submitting: false});
      });
    }
    else{
      this.setState({errors: errors});
    }

  }

  

  render_parents_info = (child_data, children_data, errors, idx, school_target) => {
    return <>
      <div className="col col-md-6 col-12">
        <div className="field">
          <label>{this.props.t(["format_3"].indexOf(this.inscription_format) !== -1 ?  "Nom du père" : ["format_2", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 ? "Nom du parent/tuteur" : ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Father's last name (or guardian)" : "Nom du père")} {["format_2", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 ? " *" : ""}</label>
          <input type="text" value={child_data.responsable_last_name} placeholder={this.props.t(["format_3"].indexOf(this.inscription_format) !== -1 ?  "Nom du père" : ["format_2", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 ? "Nom du parent/tuteur" : ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Father's last name (or guardian)" : "Nom du père")  + (["format_2", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 ? " *" : "")} onChange={evt => {
            children_data = children_data.map(child_data_ => {
              child_data_.responsable_last_name = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
              return child_data_;
            });
            errors[child_data.key].responsable_last_name = "";
            this.setState({
              children_data: children_data,
              errors: errors,
            });
          }}/>
          <div className="error">
            {errors[child_data.key].responsable_last_name}
          </div>
        </div>
      </div>
      <div className="col col-md-6 col-12">
        <div className="field">
          <label>{this.props.t(["format_3"].indexOf(this.inscription_format) !== -1 ?  "Prénom du père" : ["format_2", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 ? "Prénom du parent/tuteur" : ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Father's first name (or guardian)" : "Prénom du père")}</label>
          <input type="text" value={child_data.responsable_first_name} placeholder={this.props.t(["format_3"].indexOf(this.inscription_format) !== -1 ?  "Prénom du père" : ["format_2", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 ? "Prénom du parent/tuteur" : ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Father's first name (or guardian)" : "Prénom du père")  + (["format_2", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 ? " *" : "")} onChange={evt => {
            children_data = children_data.map(child_data_ => {
              child_data_.responsable_first_name = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
              return child_data_;
            });
            errors[child_data.key].responsable_first_name = "";
            this.setState({
              children_data: children_data,
              errors: errors,
            });
          }}/>
          <div className="error">
            {errors[child_data.key].responsable_first_name}
          </div>
        </div>
      </div>

      {this.inscription_format == "format_3" &&
        <>
          <div className="col col-md-6 col-12">
            <div className="field">
              <label className="ta_r">{this.props.t("نسب الأب")}</label>
              <input className="ta_r" type="text" value={child_data.responsable_last_name_ar} placeholder={this.props.t("نسب الأب")} onChange={evt => {
                children_data = children_data.map(child_data_ => {
                  child_data_.responsable_last_name_ar = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                  return child_data_;
                });
                errors[child_data.key].responsable_last_name_ar = "";
                this.setState({
                  children_data: children_data,
                  errors: errors,
                });
              }}/>
              <div className="error">
                {errors[child_data.key].responsable_last_name_ar}
              </div>
            </div>
          </div>
          <div className="col col-md-6 col-12">
            <div className="field">
              <label className="ta_r">{this.props.t("اسم الأب")}</label>
              <input className="ta_r" type="text" value={child_data.responsable_first_name_ar} placeholder={this.props.t("اسم الأب")} onChange={evt => {
                children_data = children_data.map(child_data_ => {
                  child_data_.responsable_first_name_ar = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                  return child_data_;
                });
                errors[child_data.key].responsable_first_name_ar = "";
                this.setState({
                  children_data: children_data,
                  errors: errors,
                });
              }}/>
              <div className="error">
                {errors[child_data.key].responsable_first_name_ar}
              </div>
            </div>
          </div>
        </>
      }
      <div className="col col-md-6 col-12" style={{minHeight: 55}}>
        <div className="field">
          <label>{this.props.t(["format_2", "format_5", "format_3", "format_6"].indexOf(this.inscription_format) !== -1 ? "GSM du parent/tuteur *": ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Mobile phone" : "GSM du père *")}</label>
          <IntlTelInput inputClassName='phone_number'
            preferredCountries={['ma']} defaultValue={child_data.gsm_1}
            onPhoneNumberChange={(status, value, countryData, number, id) => {
              children_data = children_data.map(child_data_ => {
                child_data_.gsm_1 = number;
                return child_data_;
              });
              errors[child_data.key].gsm_1 = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}
          />
          <div className="error">
            {errors[child_data.key].gsm_1}
          </div>
        </div>
      </div>
      {/* <div className="col col-md-6 col-12" style={{minHeight: 55}}>
        <div className="field">
          <label>{this.props.t(["format_2", "format_5", "format_3", "format_6"].indexOf(this.inscription_format) !== -1 ? "GSM du parent/tuteur (2)": ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Mobile phone (2)" : "GSM du père (2)")}</label>
          <IntlTelInput inputClassName='phone_number' placeholder={this.props.t(["format_2", "format_5", "format_3", "format_6"].indexOf(this.inscription_format) !== -1 ? "GSM du parent/tuteur (2)": ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Mobile phone (2)" : "GSM du père (2)")}
            preferredCountries={['ma']} defaultValue={child_data.gsm_1_2}
            onPhoneNumberChange={(status, value, countryData, number, id) => {
              children_data = children_data.map(child_data_ => {
                child_data_.gsm_1_2 = number;
                return child_data_;
              });
              errors[child_data.key].gsm_1_2 = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}
          />
          <div className="error">
            {errors[child_data.key].gsm_1_2}
          </div>
        </div>
      </div> */}
      {school_target.save_parents_birthday && 
        <div className="col col-md-6 col-12">
          <div className={"field " + (child_data.birthday1 ? "" : "empty")}>
            <label>{this.props.t(["format_3"].indexOf(this.inscription_format) !== -1 ?  "Date de naissance du père" : ["format_2", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 ? "Date de naissance du parent/tuteur" : ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Father's birthday (or guardian)" : "Date de naissance du père")}</label>
            <DatePicker
              name='birthday1'
              selected={child_data.birthday1 || null}
              onChange={(date) => {
                child_data.birthday1 = date && moment(date).startOf("day").add(12, "hours").toDate();
                children_data[idx] = child_data;
                errors[child_data.key].birthday1 = "";
                this.setState({
                  child_data: child_data,
                  errors: errors,
                });
              }}
              locale={"fr"}
              popperClassName="origin zi_100"
              showYearDropdown
              showMonthDropdown
              useShortMonthInDropdown
              dateFormat="dd/MM/yyyy"
              maxDate={moment().toDate()}
              placeholderText={this.props.t(["format_3"].indexOf(this.inscription_format) !== -1 ?  "Date de naissance du père" : ["format_2", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 ? "Date de naissance du parent/tuteur" : ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Father's birthday (or guardian)" : "Date de naissance du père")}
            />
            <div className="error">
              {errors[child_data.key].birthday1}
            </div>
          </div>
        </div>
      }
      {(school_target.save_parents_companies && this.inscription_format == "format_3") &&
        <div className="col col-md-6 col-12">
          <div className="field">
            <label>{this.props.t("Company")}</label>
            <input type="text" value={child_data.company1} placeholder={this.props.t("Company")} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.company1 = evt.target.value;
                return child_data_;
              });
              errors[child_data.key].company1 = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].company1}
            </div>
          </div>
        </div>
      }

      {["format_4"].indexOf(this.inscription_format) !== -1 &&
        <div className="col col-md-6 col-12">
          <div className="field">
            <label>{this.props.t("CIN number")}</label>
            <input type="text" value={child_data.cin_father} placeholder={this.props.t("CIN number")} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.cin_father = evt.target.value;
                return child_data_;
              });
              errors[child_data.key].cin_father = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].cin_father}
            </div>
          </div>
        </div>
      }
      {["format_4"].indexOf(this.inscription_format) !== -1 && 
        <div className="col col-md-6 col-12">
          <div className="field">
            <label>{this.props.t("Nationality")}</label>
            <input type="text" value={child_data.nationality1} placeholder={this.props.t("Nationality")} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.nationality1 = evt.target.value;
                return child_data_;
              });
              errors[child_data.key].nationality1 = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].nationality1}
            </div>
          </div>
        </div>
      }
      {["format_4"].indexOf(this.inscription_format) !== -1 && 
        <div className="col col-md-6 col-12">
          <div className="field"> 
            <label>{this.props.t("Occupation")}</label>
            {/* <div className="select">
              <select value={profession_1_id || ""} className={profession_1_id ? "selected" : ""} onChange={evt => {
                children_data = children_data.map(child_data_ => {
                  child_data_.profession1 = evt.target.options[evt.target.selectedIndex].text;
                  return child_data_;
                });
                errors[child_data.key].profession1 = "";
                this.setState({
                  children_data: children_data,
                  errors: errors,
                });
              }}>
                <option value="">{this.props.t("Occupation")}</option>
                {((school_target || {}).preinscription_parents_professions || []).map(ppp => (
                  <option value={ppp.id} key={ppp.id}>{ppp.name}</option>
                ))}
              </select>
              <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
            </div> */}
            <input type="text" value={child_data.profession1} placeholder={this.props.t("Occupation")} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.profession1 = evt.target.value;
                return child_data_;
              });
              errors[child_data.key].profession1 = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].profession1}
            </div>
          </div>
        </div>
      }
      {["format_4"].indexOf(this.inscription_format) !== -1 && 
        <div className="col col-md-12 col-12">
          <div className="field">
            <label>{this.props.t("Employer's address")}</label>
            <input type="text" value={child_data.work_place1} placeholder={this.props.t("Employer's address")} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.work_place1 = evt.target.value;
                return child_data_;
              });
              errors[child_data.key].work_place1 = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].work_place1}
            </div>
          </div>
        </div>
      }

      {["format_5"].indexOf(this.inscription_format) !== -1 && 
      <>
        {(this.inscription_format == "format_5") &&
        <div className="col col-md-6 col-12">
          <div className="field">
            <label>{this.props.t(["format_5"].indexOf(this.inscription_format) !== -1 ? "Email du parent/tuteur" : "Email du père") + (["format_5"].indexOf(this.inscription_format) !== -1 ? " *" : "")}</label>
            <input type="text" value={child_data.email} placeholder={this.props.t(["format_5"].indexOf(this.inscription_format) !== -1 ? "Email du parent/tuteur" : "Email du père") + (["format_5"].indexOf(this.inscription_format) !== -1 ? " *" : "")} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.email = evt.target.value;
                return child_data_;
              });
              errors[child_data.key].email = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].email}
            </div>
          </div>
        </div>
        }
      </>
      }
      {["format_1", "format_3", "format_4"].indexOf(this.inscription_format) !== -1 && 
      <>
        {this.inscription_format == "format_1" &&
        <div className="col col-md-6 col-12">
          <div className="field">
            <label>{this.props.t("Email du père")}</label>
            <input type="text" value={child_data.email} placeholder={this.props.t("Email du père")} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.email = evt.target.value;
                return child_data_;
              });
              errors[child_data.key].email = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].email}
            </div>
          </div>
        </div>
        }
        <div className="col col-md-6 col-12">
          <div className="field">
            <label>{this.props.t(["format_3"].indexOf(this.inscription_format) !== -1 ?  "Nom de la mère" : ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Mother's last name" : "Nom de la mère")}</label>
            <input type="text" value={child_data.responsable2_last_name} placeholder={this.props.t(["format_3"].indexOf(this.inscription_format) !== -1 ?  "Nom de la mère" : ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Mother's last name" : "Nom de la mère")} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.responsable2_last_name = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                return child_data_;
              });
              errors[child_data.key].responsable2_last_name = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].responsable2_last_name}
            </div>
          </div>
        </div>
        <div className="col col-md-6 col-12">
          <div className="field">
            <label>{this.props.t(["format_3"].indexOf(this.inscription_format) !== -1 ?  "Prénom de la mère" : ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Mother's first name" : "Prénom de la mère")}</label>
            <input type="text" value={child_data.responsable2_first_name} placeholder={this.props.t(["format_3"].indexOf(this.inscription_format) !== -1 ?  "Prénom de la mère" : ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Mothers's first name" : "Prénom de la mère")} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.responsable2_first_name = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                return child_data_;
              });
              errors[child_data.key].responsable2_first_name = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].responsable2_first_name}
            </div>
          </div>
        </div>
        {this.inscription_format == "format_3" &&
          <>
            <div className="col col-md-6 col-12">
              <div className="field">
                <label className="ta_r">{this.props.t("نسب الأم")}</label>
                <input className="ta_r" type="text" value={child_data.responsable2_last_name_ar} placeholder={this.props.t("نسب الأم")} onChange={evt => {
                  children_data = children_data.map(child_data_ => {
                    child_data_.responsable2_last_name_ar = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                    return child_data_;
                  });
                  errors[child_data.key].responsable2_last_name_ar = "";
                  this.setState({
                    children_data: children_data,
                    errors: errors,
                  });
                }}/>
                <div className="error">
                  {errors[child_data.key].responsable2_last_name_ar}
                </div>
              </div>
            </div>
            <div className="col col-md-6 col-12">
              <div className="field">
                <label className="ta_r">{this.props.t("اسم الأم")}</label>
                <input className="ta_r" type="text" value={child_data.responsable2_first_name_ar} placeholder={this.props.t("اسم الأم")} onChange={evt => {
                  children_data = children_data.map(child_data_ => {
                    child_data_.responsable2_first_name_ar = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                    return child_data_;
                  });
                  errors[child_data.key].responsable2_first_name_ar = "";
                  this.setState({
                    children_data: children_data,
                    errors: errors,
                  });
                }}/>
                <div className="error">
                  {errors[child_data.key].responsable2_first_name_ar}
                </div>
              </div>
            </div>
          </>
        }
        <div className="col col-md-6 col-12" style={{minHeight: 55}}>
          <div className="field">
            <label>{this.props.t(["format_4"].indexOf(this.inscription_format) !== -1 ?  "Mobile phone" : "GSM de la mère")}</label>
            <IntlTelInput inputClassName='phone_number'
              preferredCountries={['ma']} defaultValue={child_data.gsm_2}
              onPhoneNumberChange={(status, value, countryData, number, id) => {
                children_data = children_data.map(child_data_ => {
                  child_data_.gsm_2 = number;
                  return child_data_;
                });
                errors[child_data.key].gsm_2 = "";
                this.setState({
                  children_data: children_data,
                  errors: errors,
                });
              }}
            />
            <div className="error">
              {errors[child_data.key].gsm_2}
            </div>
          </div>
        </div>
        {school_target.save_parents_birthday && 
          <div className="col col-md-6 col-12">
            <div className={"field " + (child_data.birthday2 ? "" : "empty")}>
              <label>{this.props.t(["format_3"].indexOf(this.inscription_format) !== -1 ?  "Date de naissance de la mère" : ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Mother's birthday" : "Date de naissance de la mère")}</label>
              <DatePicker
                name='birthday2'
                selected={child_data.birthday2 || null}
                onChange={(date) => {
                  child_data.birthday2 = date && moment(date).startOf("day").add(12, "hours").toDate();
                  children_data[idx] = child_data;
                  errors[child_data.key].birthday2 = "";
                  this.setState({
                    child_data: child_data,
                    errors: errors,
                  });
                }}
                locale={"fr"}
                popperClassName="origin zi_100"
                showYearDropdown
                showMonthDropdown
                useShortMonthInDropdown
                dateFormat="dd/MM/yyyy"
                maxDate={moment().toDate()}
                placeholderText={this.props.t(["format_3"].indexOf(this.inscription_format) !== -1 ?  "Date de naissance de la mère" : ["format_4"].indexOf(this.inscription_format) !== -1 ?  "Mother's birthday" : "Date de naissance de la mère")}
              />
              <div className="error">
                {errors[child_data.key].birthday2}
              </div>
            </div>
          </div>
        }
        {(school_target.save_parents_companies && this.inscription_format == "format_3") &&
          <div className="col col-md-6 col-12">
            <div className="field">
              <label>{this.props.t("Company")}</label>
              <input type="text" value={child_data.company2} placeholder={this.props.t("Company")} onChange={evt => {
                children_data = children_data.map(child_data_ => {
                  child_data_.company2 = evt.target.value;
                  return child_data_;
                });
                errors[child_data.key].company2 = "";
                this.setState({
                  children_data: children_data,
                  errors: errors,
                });
              }}/>
              <div className="error">
                {errors[child_data.key].company2}
              </div>
            </div>
          </div>
        }

        {["format_4"].indexOf(this.inscription_format) !== -1 &&
          <div className="col col-md-6 col-12">
            <div className="field">
              <label>{this.props.t("CIN number")}</label>
              <input type="text" value={child_data.cin_mother} placeholder={this.props.t("CIN number")} onChange={evt => {
                children_data = children_data.map(child_data_ => {
                  child_data_.cin_mother = evt.target.value;
                  return child_data_;
                });
                errors[child_data.key].cin_mother = "";
                this.setState({
                  children_data: children_data,
                  errors: errors,
                });
              }}/>
              <div className="error">
                {errors[child_data.key].cin_mother}
              </div>
            </div>
          </div>
        }
        {["format_4"].indexOf(this.inscription_format) !== -1 && 
          <div className="col col-md-6 col-12">
            <div className="field">
              <label>{this.props.t("Nationality")}</label>
              <input type="text" value={child_data.nationality2} placeholder={this.props.t("Nationality")} onChange={evt => {
                children_data = children_data.map(child_data_ => {
                  child_data_.nationality2 = evt.target.value;
                  return child_data_;
                });
                errors[child_data.key].nationality2 = "";
                this.setState({
                  children_data: children_data,
                  errors: errors,
                });
              }}/>
              <div className="error">
                {errors[child_data.key].nationality2}
              </div>
            </div>
          </div>
        }
        {["format_4"].indexOf(this.inscription_format) !== -1 && 
          <div className="col col-md-6 col-12">
            <div className="field">
              <label>{this.props.t("Occupation")}</label>
              {/* <div className="select">
                <select value={profession_2_id || ""} className={profession_2_id ? "selected" : ""} onChange={evt => {
                  children_data = children_data.map(child_data_ => {
                    child_data_.profession2 = evt.target.options[evt.target.selectedIndex].text;
                    return child_data_;
                  });
                  errors[child_data.key].profession2 = "";
                  this.setState({
                    children_data: children_data,
                    errors: errors,
                  });
                }}>
                  <option value="">{this.props.t("Occupation")}</option>
                  {((school_target || {}).preinscription_parents_professions || []).map(ppp => (
                    <option value={ppp.id} key={ppp.id}>{ppp.name}</option>
                  ))}
                </select>
                <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
              </div> */}
              <input type="text" value={child_data.profession2} placeholder={this.props.t("Occupation")} onChange={evt => {
                children_data = children_data.map(child_data_ => {
                  child_data_.profession2 = evt.target.value;
                  return child_data_;
                });
                errors[child_data.key].profession2 = "";
                this.setState({
                  children_data: children_data,
                  errors: errors,
                });
              }}/>
              <div className="error">
                {errors[child_data.key].profession2}
              </div>
            </div>
          </div>
        }
        {["format_4"].indexOf(this.inscription_format) !== -1 && 
          <div className="col col-md-12 col-12">
            <div className="field">
              <label>{this.props.t("Employer's address")}</label>
              <input type="text" value={child_data.work_place2} placeholder={this.props.t("Employer's address")} onChange={evt => {
                children_data = children_data.map(child_data_ => {
                  child_data_.work_place2 = evt.target.value;
                  return child_data_;
                });
                errors[child_data.key].work_place2 = "";
                this.setState({
                  children_data: children_data,
                  errors: errors,
                });
              }}/>
              <div className="error">
                {errors[child_data.key].work_place2}
              </div>
            </div>
          </div>
        }
        {this.inscription_format == "format_1" &&
        <div className="col col-md-6 col-12">
          <div className="field">
            <label>{this.props.t("Email de la mère")}</label>
            <input type="text" value={child_data.email2} placeholder={this.props.t("Email de la mère")} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.email2 = evt.target.value;
                return child_data_;
              });
              errors[child_data.key].email2 = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].email2}
            </div>
          </div>
        </div>
        }
        {false && this.inscription_format == "format_3" && // 
        <div className="col col-md-6 col-12">
          <div className="field">
            <label>{ this.props.t("Gender") }</label>
            <div className="d_flex">
              <MuiThemeProvider theme={theme}>
                <div className="radios">
                  <RadioEl 
                    value={child_data.gender == "m"} 
                    onclick={() => {
                      child_data.gender = child_data.gender == "m" ? "" : "m";
                      children_data[idx] = child_data;
                      this.setState({
                        child_data: child_data,
                      });
                    }} 
                    label={this.props.t('Male')} 
                    active={child_data.gender == "m"}
                  />
                  <RadioEl 
                    value={child_data.gender == "f"} 
                    onclick={() => {
                      child_data.gender = child_data.gender == "f" ? "" : "f";
                      children_data[idx] = child_data;
                      this.setState({
                        child_data: child_data,
                      });
                    }} 
                    label={this.props.t('Female')} 
                    active={child_data.gender == "f"}
                  />
                </div>
              </MuiThemeProvider>
            </div>
          </div>
        </div>
        }
      </>
      }
      {["format_3"].indexOf(this.inscription_format) !== -1 && 
      <>
        <div className="col col-md-12 col-12">
          <div className="field">
            <label>{this.props.t("Adresse postale")}</label>
            <input type="text" value={child_data.address} placeholder={this.props.t("Adresse postale")} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.address = evt.target.value;
                return child_data_;
              });
              errors[child_data.key].address = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].address}
            </div>
          </div>
        </div>
      </>
      }
      {school_target.id == 395 && ["format_2"].indexOf(this.inscription_format) !== -1 && 
      <>
        <div className="col col-md-6 col-12">
          <div className="field">
            <label>{"Nom du parent/tuteur 2"}</label>
            <input type="text" value={child_data.responsable2_last_name} placeholder={"Nom du parent/tuteur 2"} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.responsable2_last_name = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                return child_data_;
              });
              errors[child_data.key].responsable2_last_name = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].responsable2_last_name}
            </div>
          </div>
        </div>
        <div className="col col-md-6 col-12">
          <div className="field">
            <label>{"Prénom du parent/tuteur 2"}</label>
            <input type="text" value={child_data.responsable2_first_name} placeholder={"Prénom du parent/tuteur 2"} onChange={evt => {
              children_data = children_data.map(child_data_ => {
                child_data_.responsable2_first_name = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                return child_data_;
              });
              errors[child_data.key].responsable2_first_name = "";
              this.setState({
                children_data: children_data,
                errors: errors,
              });
            }}/>
            <div className="error">
              {errors[child_data.key].responsable2_first_name}
            </div>
          </div>
        </div>
        <div className="col col-md-6 col-12" style={{minHeight: 55}}>
          <div className="field">
            <label>{"GSM du parent/tuteur 2"}</label>
            <IntlTelInput inputClassName='phone_number'
              preferredCountries={['ma']} defaultValue={child_data.gsm_2}
              onPhoneNumberChange={(status, value, countryData, number, id) => {
                children_data = children_data.map(child_data_ => {
                  child_data_.gsm_2 = number;
                  return child_data_;
                });
                errors[child_data.key].gsm_2 = "";
                this.setState({
                  children_data: children_data,
                  errors: errors,
                });
              }}
            />
            <div className="error">
              {errors[child_data.key].gsm_2}
            </div>
          </div>
        </div>
      </>
      }
    </>
  }
  render_birthday = (child_data, children_data, errors, idx) => {
    return <>
      <div className="col col-md-6 col-12">
        <div className={"field " + (child_data.birthday ? "" : "empty")}>
          <label>{this.props.t("Date de naissance")} {["format_5", "format_2", "format_6"].indexOf(this.inscription_format) !== -1 ? " *" : ""}</label>
          <DatePicker
            name='birthday'
            selected={child_data.birthday || null}
            onChange={(date) => {
              child_data.birthday = date && moment(date).startOf("day").add(12, "hours").toDate();
              children_data[idx] = child_data;
              errors[child_data.key].birthday = "";
              this.setState({
                child_data: child_data,
                errors: errors,
              });
            }}
            locale={"fr"}
            popperClassName="origin zi_100"
            showYearDropdown
            showMonthDropdown
            useShortMonthInDropdown
            dateFormat="dd/MM/yyyy"
            maxDate={moment().toDate()}
            placeholderText={this.props.t("Date de naissance")  + (["format_5", "format_2", "format_6"].indexOf(this.inscription_format) !== -1 ? " *" : "")}
          />
          <div className="error">
            {errors[child_data.key].birthday}
          </div>
        </div>
      </div>
    </>
  }


  render_body = (school_target, is_mobile) => {
    var levels = [];
    var levels_groups = [];
    if(school_target){
      school_target.levels_groups.map(lg => {
        levels_groups.push(lg);
        levels = levels.concat(lg.levels);
      });
    }
    var {children_data, errors, selected_scholar_year, next_scholar_year, is_submitting, succession_message, all_schools_targets} = this.state;
    var unconnected_inscription_configuration = (school_target || {}).unconnected_inscription_configuration;
    return <div className="body">
      {!this.params.get('hide_logo') && <>
      <div className="row title" style={{color: (unconnected_inscription_configuration.style || {}).form_title_color || "blue"}}>
        {this.props.t("Inscription en ligne") + " " + (next_scholar_year ? next_scholar_year.name : selected_scholar_year.name)}
      </div>
      {["format_2"].indexOf(this.inscription_format) !== -1 &&
        <div className="row title" style={{paddingTop: 0, marginTop: -30, color: (unconnected_inscription_configuration.style || {}).form_title_color || "blue"}}>
          {(next_scholar_year ? next_scholar_year.name : selected_scholar_year.name) + " " + this.props.t("التسجيل") }
        </div>
      }
      </>
      }
      {succession_message ?
        <div className="succession_message">
          {succession_message}
        </div>
        :
        <>
          {all_schools_targets.length > 1 &&
            <div className={"row formular "} style={{paddingBottom: 0}} >
              <div className="col col-md-12 col-12"  style={{marginBottom: 0}}>
                <div className="field">
                  <label style={{display: "block"}}>{this.props.t("Site à proximité")}</label>
                  <div className="select">
                    <select style={{marginBottom: 0}} value={school_target.id} className={"selected"} onChange={evt => {
                      var selected_school_target = all_schools_targets.filter(st => st.id == evt.target.value)[0];
                      this.inscription_format = ((selected_school_target || {}).unconnected_inscription_configuration || {}).format || "format_1";
                      this.save_names_in_uppercase_in_preinscription = selected_school_target && selected_school_target.save_names_in_uppercase_in_preinscription || false;
                      this.setState({
                        school_target: selected_school_target,
                      });
                      if(selected_school_target && selected_school_target.meta_pixel_id){
                        installMetaPixel(selected_school_target.meta_pixel_id);
                      }
                      if(selected_school_target && selected_school_target.google_tag_id){
                        installGoogleTag(selected_school_target.google_tag_id, window.location.pathname.indexOf("inscription-madina-schools-merci/") > -1);
                      }
                      if(selected_school_target && selected_school_target.clarity_project_id){
                        installMicrosoftClarity(selected_school_target.clarity_project_id);
                      }
                    }}>
                      {all_schools_targets.map(st => (
                        <option value={st.id} key={st.id}>{st.name}</option>
                      ))}
                    </select>
                    <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          }
          {children_data.map((child_data, idx) => {
            if(!errors[child_data.key]){
              errors[child_data.key] = {};
            }
            let profession_1 = ((school_target || {}).preinscription_parents_professions || []).filter(ppp => ppp.name == child_data.profession1)[0];
            let profession_1_id = profession_1 && profession_1.id;
            let profession_2 = ((school_target || {}).preinscription_parents_professions || []).filter(ppp => ppp.name == child_data.profession2)[0];
            let profession_2_id = profession_2 && profession_2.id;
            let previous_school = ((school_target || {}).preinscription_previow_schools || []).filter(ppp => ppp.name == child_data.actual_school)[0];
            let previous_school_id = child_data.previous_school_id || previous_school && previous_school.id;
            if(!previous_school_id && child_data.actual_school){
              previous_school_id = "other";
            }
            return <div className={"row formular " + (children_data.length > 1 ? "styled" : "")} key={child_data.key}>

              {children_data.length > 1 &&
              <>
                <span className="child_title">
                  {this.props.t("Child") + " " + (idx + 1) + ":"}
                </span>
                <div class="removeChild" onClick={(evt) => {
                  this.setState({
                    children_data: children_data.filter(ch => {
                      return ch.key != child_data.key;
                    })
                  });
                }}>x</div>
              </>
              }
              {idx == 0 && ["format_6"].indexOf(this.inscription_format) !== -1 &&
                <>
                  {this.render_parents_info(child_data, children_data, errors, idx, school_target)}
                </>
              }
              <div className="col col-md-6 col-12">
                <div className="field">
                  <label>{this.props.t("Nom de l'élève *")}</label>
                  <input type="text" value={child_data.last_name} placeholder={this.props.t("Nom de l'élève *")} onChange={evt => {
                    child_data.last_name = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                    children_data[idx] = child_data;
                    errors[child_data.key].last_name = "";
                    this.setState({
                      children_data: children_data,
                      errors: errors,
                    });
                  }}/>
                  <div className="error">
                    {errors[child_data.key].last_name}
                  </div>
                </div>
              </div>
              <div className="col col-md-6 col-12">
                <div className="field">
                  <label>{this.props.t("Prénom de l'élève *")}</label>
                  <input type="text" value={child_data.first_name} placeholder={this.props.t("Prénom de l'élève *")} onChange={evt => {
                    child_data.first_name = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                    children_data[idx] = child_data;
                    errors[child_data.key].first_name = "";
                    this.setState({
                      children_data: children_data,
                      errors: errors,
                    });
                  }}/>
                  <div className="error">
                    {errors[child_data.key].first_name}
                  </div>
                </div>
              </div>
              {(true || this.inscription_format == "format_3") &&
              <>
                <div className="col col-md-6 col-12">
                  <div className="field">
                    <label  className="ta_r">{this.props.t("نسب التلميذ")}</label>
                    <input className="ta_r" type="text" value={child_data.last_name_ar} placeholder={this.props.t("نسب التلميذ")} onChange={evt => {
                      child_data.last_name_ar = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                      children_data[idx] = child_data;
                      errors[child_data.key].last_name_ar = "";
                      this.setState({
                        children_data: children_data,
                        errors: errors,
                      });
                    }}/>
                    <div className="error">
                      {errors[child_data.key].last_name_ar}
                    </div>
                  </div>
                </div>
                <div className="col col-md-6 col-12">
                  <div className="field">
                    <label className="ta_r">{this.props.t("اسم التلميذ")}</label>
                    <input className="ta_r" type="text" value={child_data.first_name_ar} placeholder={this.props.t("اسم التلميذ")} onChange={evt => {
                      child_data.first_name_ar = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                      children_data[idx] = child_data;
                      errors[child_data.key].first_name_ar = "";
                      this.setState({
                        children_data: children_data,
                        errors: errors,
                      });
                    }}/>
                    <div className="error">
                      {errors[child_data.key].first_name_ar}
                    </div>
                  </div>
                </div>
              </>
              }
              {["format_6"].indexOf(this.inscription_format) !== -1 && this.render_birthday(child_data, children_data, errors, idx)}
              {["format_6"].indexOf(this.inscription_format) !== -1 && 
                <div className="col col-md-6 col-12">
                  <div className="field">
                    <label>{this.props.t("Cycle")}</label>
                    <div className="select">
                      <select value={child_data.level_group_id || ""} className={child_data.level_group_id ? "selected" : ""} onChange={evt => {
                        child_data.level_group_id = evt.target.value;
                        children_data[idx] = child_data;
                        errors[child_data.key].level_group = "";
                        this.setState({
                          child_data: child_data,
                          errors: errors,
                        });
                      }}>
                        <option value="">{this.props.t(["format_6"].indexOf(this.inscription_format) !== -1 ? "Cycle" : ["format_5", "format_2"].indexOf(this.inscription_format) !== -1 ? "Sélectionner le cycle demandé pour l'année scolaire " : "Sélectionner le cycle pour l'année scolaire ") + (["format_6"].indexOf(this.inscription_format) !== -1 ? "" : (next_scholar_year ? next_scholar_year.name : selected_scholar_year.name))}</option>
                        {levels_groups.map(level_group => (
                          <option value={level_group.id} key={level_group.id}>{level_group.name}</option>
                        ))}
                      </select>
                      <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                      <div className="added_info_level hidden">
                        {this.props.t("de l'année scolaire ") + (next_scholar_year ? next_scholar_year.name : selected_scholar_year.name)}
                      </div>
                    </div>
                    <div className="error">
                      {errors[child_data.key].level_group_id}
                    </div>
                  </div>
                </div>
              }
              <div className={["format_6"].indexOf(this.inscription_format) !== -1 ? "col col-md-6 col-12" : "col col-md-12 col-12"}>
                <div className="field">
                  <label>{this.props.t("Niveau *")}</label>
                  <div className="select">
                    <select value={child_data.level_id || ""} className={child_data.level_id ? "selected" : ""} onChange={evt => {
                      child_data.level_id = evt.target.value;
                      if(!child_data.level_group_id){
                        let lvl = levels.filter(lvl_ => lvl_.level_id == child_data.level_id)[0]
                        child_data.level_group_id = lvl ? lvl.group_id : child_data.level_group_id;
                      }
                      children_data[idx] = child_data;
                      errors[child_data.key].level = "";
                      this.setState({
                        child_data: child_data,
                        errors: errors,
                      });
                    }}>
                      {/* <option value="">{this.props.t("Select level")}</option> */}
                      <option value="">{this.props.t(["format_6"].indexOf(this.inscription_format) !== -1 ? "Level requested" : ["format_5", "format_2"].indexOf(this.inscription_format) !== -1 ? "Sélectionner le niveau demandé pour l'année scolaire " : "Sélectionner le niveau pour l'année scolaire ") + (["format_6"].indexOf(this.inscription_format) !== -1 ? "" : (next_scholar_year ? next_scholar_year.name : selected_scholar_year.name))}</option>
                      {levels.filter(lvl => {
                        return ["format_6"].indexOf(this.inscription_format) === -1 || !child_data.level_group_id || child_data.level_group_id == lvl.group_id;
                      }).map(level => (
                        <option value={level.level_id} key={level.level_id}>{level.name}</option>
                      ))}
                    </select>
                    <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                    <div className="added_info_level hidden">
                      {this.props.t("de l'année scolaire ") + (next_scholar_year ? next_scholar_year.name : selected_scholar_year.name)}
                    </div>
                  </div>
                  <div className="error">
                    {errors[child_data.key].level}
                  </div>
                </div>
              </div>
              {["format_6"].indexOf(this.inscription_format) == -1 && this.render_birthday(child_data, children_data, errors, idx)}
              {["format_6"].indexOf(this.inscription_format) == -1 &&
              <>
              {["format_2", "format_3", "format_5"].indexOf(this.inscription_format) !== -1 ?
              <>
                <div className="col col-md-6 col-12">
                  <div className="field">
                    <label>{this.props.t("Établissement scolaire actuel")}</label>
                    {["format_3"].indexOf(this.inscription_format) !== -1 ? 
                      <>
                        <div className="select" style={{position: "relative"}}>
                          {previous_school_id == "other" ? 
                          <>
                            <input type="text" value={child_data.actual_school} placeholder={this.props.t("Établissement scolaire actuel")} onChange={evt => {
                              child_data.actual_school = evt.target.value;
                              children_data[idx] = child_data;
                              errors[child_data.key].actual_school = "";
                              this.setState({
                                child_data: child_data,
                                errors: errors,
                              });
                            }}
                            style={{border: 0, height: "99%"}}
                            />
                            <i className="fa fa-close" aria-hidden="true" style={{color: "red", cursor: "pointer"}} onClick={evt => {
                              child_data.previous_school_id = "";
                              child_data.actual_school = "";
                              children_data[idx] = child_data;
                              this.setState({
                                child_data: child_data,
                              });
                            }}></i>
                          </>
                          :
                          <>
                            <select value={previous_school_id || ""} className={previous_school_id ? "selected" : ""} onChange={evt => {
                              
                              child_data.actual_school = evt.target.value == "other" && previous_school_id ? "" : evt.target.value == "other" ? child_data.actual_school : evt.target.options[evt.target.selectedIndex].text;
                              child_data.previous_school_id = evt.target.value;
                              // child_data.actual_school = evt.target.options[evt.target.selectedIndex].text;
                              children_data[idx] = child_data;
                              errors[child_data.key].actual_school = "";
                              this.setState({
                                child_data: child_data,
                                errors: errors,
                              });
                            }}>
                              <option value="">{this.props.t("Établissement scolaire actuel")}</option>
                              {((school_target || {}).preinscription_previow_schools || []).map(pps => (
                                <option value={pps.id} key={pps.id}>{pps.name}</option>
                              ))}
                              <option value="other">{this.props.t("Autre")}</option>
                            </select>
                            <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                          </>}
                        </div>
                      </>
                      :
                      <>
                        <input type="text" value={child_data.actual_school} placeholder={this.props.t("Établissement scolaire actuel")} onChange={evt => {
                          child_data.actual_school = evt.target.value;
                          children_data[idx] = child_data;
                          errors[child_data.key].actual_school = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                      </>
                    }
                    <div className="error">
                      {errors[child_data.key].actual_school}
                    </div>
                  </div>
                </div>

                {this.inscription_format == "format_3" &&
                  <div className="col col-md-6 col-12">
                    <div className="field">
                      <label>{ this.props.t("Gender") }</label>
                      <div className="d_flex">
                        <MuiThemeProvider theme={theme}>
                          <div className="radios">
                            <RadioEl 
                              value={child_data.gender == "m"} 
                              onclick={() => {
                                child_data.gender = child_data.gender == "m" ? "" : "m";
                                children_data[idx] = child_data;
                                this.setState({
                                  child_data: child_data,
                                });
                              }} 
                              label={this.props.t('Male')} 
                              active={child_data.gender == "m"}
                            />
                            <RadioEl 
                              value={child_data.gender == "f"} 
                              onclick={() => {
                                child_data.gender = child_data.gender == "f" ? "" : "f";
                                children_data[idx] = child_data;
                                this.setState({
                                  child_data: child_data,
                                });
                              }} 
                              label={this.props.t('Female')} 
                              active={child_data.gender == "f"}
                            />
                          </div>
                        </MuiThemeProvider>
                      </div>
                    </div>
                  </div>
                }
              </>
              :
              <>
                <div className="col col-md-6 col-12">
                  <div className="field">
                    <label>{this.props.t("Birth place")}</label>
                    <input type="text" value={child_data.birth_place} placeholder={this.props.t("Birth place")} onChange={evt => {
                      child_data.birth_place = evt.target.value;
                      children_data[idx] = child_data;
                      errors[child_data.key].birth_place = "";
                      this.setState({
                        child_data: child_data,
                        errors: errors,
                      });
                    }}/>
                    <div className="error">
                      {errors[child_data.key].birth_place}
                    </div>
                  </div>
                </div>
                <div className="col col-md-6 col-12">
                  <div className="field">
                    <label>{this.props.t("Birth place (ar)")}</label>
                    <input className="ta_r" type="text" value={child_data.birth_place_ar} placeholder={this.props.t("Birth place (ar)")} onChange={evt => {
                      child_data.birth_place_ar = evt.target.value;
                      children_data[idx] = child_data;
                      errors[child_data.key].birth_place_ar = "";
                      this.setState({
                        child_data: child_data,
                        errors: errors,
                      });
                    }}/>
                    <div className="error">
                      {errors[child_data.key].birth_place_ar}
                    </div>
                  </div>
                </div>
                {["format_4"].indexOf(this.inscription_format) === -1 &&
                <div className="col col-md-12 col-12">
                  <div className="field bulletin">
                    <label>{ this.props.t('Bulletin') }:</label>
                    {child_data.bulletin_link ?
                    <>
                      <div className="doc">
                        <span className="name text_overflow" title={format_s3_file_name(child_data.bulletin_link, null, "___")}>{format_s3_file_name(child_data.bulletin_link, null, "___")}</span>
                      </div>
                      {!this.state.bulletin_uploading ?
                        <div className="actions">
                          {child_data.bulletin_link.indexOf("http") > -1 ?
                            <Button variant='circle' 
                              className="btn-green download_file" 
                              onClick={() => {
                                var url = child_data.bulletin_link;
                                if(url.indexOf("http") === -1){
                                  url = "http://" + url;
                                }
                                window.open(url,"_blank");
                              }}>
                              <i className="fa fa-download download_file"></i>
                            </Button>
                          :
                            <span></span>
                          }
                          <span className="remove_document" onClick={evt => {
                            child_data.bulletin_link = "";
                            children_data[idx] = child_data;
                            this.setState({
                              child_data: child_data
                            });
                          }}><i class="fa fa-trash"></i></span>
                        </div>
                      :
                        <img className="file_uploading_act" src={images.iconFileGenerating} title="File uploading" style={{width: "28px", height: "28px"}}/>
                      }
                    </>
                    :
                      <div className="">
                        <Button variant="rounded" disabled={this.state.bulletin_uploading} style={{color: (unconnected_inscription_configuration.style || {}).header_bg || "#3eb6ad"}}>
                          {!this.state.bulletin_uploading &&
                            <input type="file" onChange={(evt) => this.handleBrowseFiles(evt)}
                              accept="image/*,.pdf,.doc,.docx"
                            />
                          }
                          {this.props.t('Télécharger le bulletin')}
                          {(this.state.bulletin_uploading) &&
                            <img className="file_uploading" src={images.iconFileGenerating} title="File uploading" style={{width: "28px", height: "28px", position: "absolute", left: "50%", top: "0%", transform: "translate(-50%, 0%)"}}/>
                          }
                        </Button>
                      </div>
                    }
                  </div>
                </div>
                }
                <div className="col col-md-12 col-12">
                  <div className="field">
                    <label>{this.props.t("Adresse")}</label>
                    <input type="text" value={child_data.address} placeholder={this.props.t("Adresse")} onChange={evt => {
                      child_data.address = evt.target.value;
                      children_data[idx] = child_data;
                      errors[child_data.key].address = "";
                      this.setState({
                        child_data: child_data,
                        errors: errors,
                      });
                    }}/>
                    <div className="error">
                      {errors[child_data.key].address}
                    </div>
                  </div>
                </div>
                {["format_4"].indexOf(this.inscription_format) !== -1 &&
                  <>
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("Nationality")}</label>
                        <input type="text" value={child_data.insc_child_nationality} placeholder={this.props.t("Nationality")} onChange={evt => {
                          child_data.insc_child_nationality = evt.target.value;
                          children_data[idx] = child_data;
                          errors[child_data.key].insc_child_nationality = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].insc_child_nationality}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("Last classe attended")}</label>
                        {/* <div className="select">
                          <select value={previous_school_id || ""} className={previous_school_id ? "selected" : ""} onChange={evt => {
                            child_data.actual_school = evt.target.options[evt.target.selectedIndex].text;
                            children_data[idx] = child_data;
                            errors[child_data.key].actual_school = "";
                            this.setState({
                              child_data: child_data,
                              errors: errors,
                            });
                          }}>
                            <option value="">{this.props.t("Last classe attended")}</option>
                            {((school_target || {}).preinscription_previow_schools || []).map(pps => (
                              <option value={pps.id} key={pps.id}>{pps.name}</option>
                            ))}
                          </select>
                          <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                        </div> */}
                        <input type="text" value={child_data.actual_school} placeholder={this.props.t("Last classe attended")} onChange={evt => {
                          child_data.actual_school = evt.target.value;
                          children_data[idx] = child_data;
                          errors[child_data.key].actual_school = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].actual_school}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("Redouble")}</label>
                        <Checkbox shape="curve" color="info" className="checkbox-form "
                          onChange={(evt) => {
                            child_data.redoublant = !child_data.redoublant;
                            children_data[idx] = child_data;
                            errors[child_data.key].redoublant = "";
                            this.setState({
                              child_data: child_data,
                              errors: errors,
                            });
                          }}
                          checked={child_data.redoublant}
                        >
                          {this.props.t("Redouble")}
                        </Checkbox>
                      </div>
                    </div>
                  </>
                }
              </>}
              </>
              }
              {idx == 0 && ["format_6"].indexOf(this.inscription_format) === -1 &&
                <>
                  {this.render_parents_info(child_data, children_data, errors, idx, school_target)}
                </>
              }

              {["format_4"].indexOf(this.inscription_format) !== -1 &&
                <div className="col col-md-12 col-12 section_div health_section">
                  <div className="title">{this.props.t("MEDICAL BACKGROUND")}</div>
                  <div className="row">
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("Blood group")}</label>
                        <input type="text" value={child_data.blood_group} placeholder={this.props.t("Blood group")} onChange={evt => {
                          child_data.blood_group = evt.target.value;
                          children_data[idx] = child_data;
                          errors[child_data.key].blood_group = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].blood_group}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("Doctor's last name")}</label>
                        <input type="text" value={child_data.child_doctor_last_name} placeholder={this.props.t("Doctor's last name")} onChange={evt => {
                          child_data.child_doctor_last_name = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                          children_data[idx] = child_data;
                          errors[child_data.key].child_doctor_last_name = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].child_doctor_last_name}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("Doctor's first name")}</label>
                        <input type="text" value={child_data.child_doctor_first_name} placeholder={this.props.t("Doctor's first name")} onChange={evt => {
                          child_data.child_doctor_first_name = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                          children_data[idx] = child_data;
                          errors[child_data.key].child_doctor_first_name = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].child_doctor_first_name}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-12" style={{minHeight: 55}}>
                      <div className="field">
                        <label>{this.props.t("Doctor's phone")}</label>
                        <IntlTelInput inputClassName='phone_number'
                          preferredCountries={['ma']} defaultValue={child_data.child_doctor_phone}
                          onPhoneNumberChange={(status, value, countryData, number, id) => {
                            children_data = children_data.map(child_data_ => {
                              child_data_.child_doctor_phone = number;
                              return child_data_;
                            });
                            errors[child_data.key].child_doctor_phone = "";
                            this.setState({
                              children_data: children_data,
                              errors: errors,
                            });
                          }}
                        />
                        <div className="error">
                          {errors[child_data.key].child_doctor_phone}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-12 col-12">
                      <div className="field">
                        <label>{this.props.t("Doctor's address")}</label>
                        <input type="text" value={child_data.child_doctor_address} placeholder={this.props.t("Doctor's address")} onChange={evt => {
                          child_data.child_doctor_address = evt.target.value;
                          children_data[idx] = child_data;
                          errors[child_data.key].child_doctor_address = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].child_doctor_address}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("Is your child allergic to any particular medicine?")}</label>
                        <Checkbox shape="curve" color="info" className="checkbox-form"
                          onChange={(evt) => {
                            child_data.have_a_health_problem = !child_data.have_a_health_problem;
                            children_data[idx] = child_data;
                            errors[child_data.key].have_a_health_problem = "";
                            this.setState({
                              child_data: child_data,
                              errors: errors,
                            });
                          }}
                          checked={child_data.have_a_health_problem}
                        >
                          {this.props.t("Is your child allergic to any particular medicine?")}
                        </Checkbox>
                      </div>
                    </div>
                    {child_data.have_a_health_problem &&
                      <div className="col col-md-6 col-12">
                        <div className="field">
                          <label>{this.props.t("Specify which")}</label>
                          <input type="text" value={child_data.health_problem} placeholder={this.props.t("Specify which")} onChange={evt => {
                            child_data.health_problem = evt.target.value;
                            children_data[idx] = child_data;
                            errors[child_data.key].health_problem = "";
                            this.setState({
                              child_data: child_data,
                              errors: errors,
                            });
                          }}/>
                          <div className="error">
                            {errors[child_data.key].health_problem}
                          </div>
                        </div>
                      </div>
                    }
                    <div className="col col-md-12 col-12">
                      <div className="field">
                        <label className="d_b_i">{this.props.t("In the event of an accident, who would you like us to notify?")}</label>
                        <div className="input_choices">
                          {(child_data.gsm_1 || child_data.gsm_1_2) && (
                            <Checkbox shape="round" color="info" className="checkbox-form" onChange={evt => {
                              child_data.emergency_contact = child_data.emergency_contact == "1" ? "" : "1";
                              children_data[idx] = child_data;
                              errors[child_data.key].emergency_contact = "";
                              this.setState({
                                child_data: child_data,
                                errors: errors,
                              });
                            }}
                              checked={child_data.emergency_contact == "1"}
                            >
                              <span>{this.props.t('Parent ')+"1"}</span>
                            </Checkbox>
                          )}
                          {child_data.gsm_2 && (
                            <Checkbox shape="round" color="info" className="checkbox-form" onChange={evt => {
                              child_data.emergency_contact = child_data.emergency_contact == "2" ? "" : "2";
                              children_data[idx] = child_data;
                              errors[child_data.key].emergency_contact = "";
                              this.setState({
                                child_data: child_data,
                                errors: errors,
                              });
                            }}
                              checked={child_data.emergency_contact == "2"}
                            >
                              <span>{this.props.t('Parent ')+"2"}</span>
                            </Checkbox>
                          )}
                          <Checkbox shape="round" color="info" className="checkbox-form" onChange={evt => {
                            child_data.emergency_contact = child_data.emergency_contact == "o" ? "" : "o";
                            children_data[idx] = child_data;
                            errors[child_data.key].emergency_contact = "";
                            this.setState({
                              child_data: child_data,
                              errors: errors,
                            });
                          }}
                            checked={child_data.emergency_contact == "o"}
                          >
                            <span>{this.props.t('Other')}</span>
                          </Checkbox>
                        </div>
                      </div>
                    </div>
                    {child_data.emergency_contact == "o" && 
                      <>
                        <div className="col col-md-6 col-12">
                          <div className="field">
                            <label>{this.props.t("Emergency person's last name")}</label>
                            <input type="text" value={child_data.emergency_contact_last_name} placeholder={this.props.t("Emergency person's last name")} onChange={evt => {
                              child_data.emergency_contact_last_name = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                              children_data[idx] = child_data;
                              errors[child_data.key].emergency_contact_last_name = "";
                              this.setState({
                                child_data: child_data,
                                errors: errors,
                              });
                            }}/>
                            <div className="error">
                              {errors[child_data.key].emergency_contact_last_name}
                            </div>
                          </div>
                        </div>
                        <div className="col col-md-6 col-12">
                          <div className="field">
                            <label>{this.props.t("Emergency person's first name")}</label>
                            <input type="text" value={child_data.emergency_contact_first_name} placeholder={this.props.t("Emergency person's first name")} onChange={evt => {
                              child_data.emergency_contact_first_name = this.transformText(this.save_names_in_uppercase_in_preinscription, evt.target.value);
                              children_data[idx] = child_data;
                              errors[child_data.key].emergency_contact_first_name = "";
                              this.setState({
                                child_data: child_data,
                                errors: errors,
                              });
                            }}/>
                            <div className="error">
                              {errors[child_data.key].emergency_contact_first_name}
                            </div>
                          </div>
                        </div>
                        <div className="col col-md-6 col-12" style={{minHeight: 55}}>
                          <div className="field">
                            <label>{this.props.t("Emergency person's phone")}</label>
                            <IntlTelInput inputClassName='phone_number'
                              preferredCountries={['ma']} defaultValue={child_data.emergency_contact_phone}
                              onPhoneNumberChange={(status, value, countryData, number, id) => {
                                children_data = children_data.map(child_data_ => {
                                  child_data_.emergency_contact_phone = number;
                                  return child_data_;
                                });
                                errors[child_data.key].emergency_contact_phone = "";
                                this.setState({
                                  children_data: children_data,
                                  errors: errors,
                                });
                              }}
                            />
                            <div className="error">
                              {errors[child_data.key].emergency_contact_phone}
                            </div>
                          </div>
                        </div>
                        <div className="col col-md-6 col-12">
                          <div className="field">
                            <label>{this.props.t("Emergency person's address")}</label>
                            <input type="text" value={child_data.emergency_contact_address} placeholder={this.props.t("Emergency person's address")} onChange={evt => {
                              child_data.emergency_contact_address = evt.target.value;
                              children_data[idx] = child_data;
                              errors[child_data.key].emergency_contact_address = "";
                              this.setState({
                                child_data: child_data,
                                errors: errors,
                              });
                            }}/>
                            <div className="error">
                              {errors[child_data.key].emergency_contact_address}
                            </div>
                          </div>
                        </div>
                      </>
                    }
                  </div>
                </div>
              }
              {["format_4"].indexOf(this.inscription_format) !== -1 &&
                <div className="col col-md-12 col-12 section_div specific_section">
                  <div className="title">{this.props.t("SPECIFIC INFORMATION")}</div>
                  <div className="row">
                    <div className="col col-md-12 col-12">
                      <div className="field">
                        <label className="d_b_i">{this.props.t("Does the child live with")}</label>
                        <div className="input_choices c_25">
                          <Checkbox shape="round" color="info" className="checkbox-form" onChange={evt => {
                            child_data.child_lives_with = child_data.child_lives_with == "parents" ? "" : "parents";
                            children_data[idx] = child_data;
                            errors[child_data.key].child_lives_with = "";
                            this.setState({
                              child_data: child_data,
                              errors: errors,
                            });
                          }}
                            checked={child_data.child_lives_with == "parents"}
                          >
                            <span>{this.props.t('His parents')}</span>
                          </Checkbox>
                          <Checkbox shape="round" color="info" className="checkbox-form" onChange={evt => {
                            child_data.child_lives_with = child_data.child_lives_with == "father" ? "" : "father";
                            children_data[idx] = child_data;
                            errors[child_data.key].child_lives_with = "";
                            this.setState({
                              child_data: child_data,
                              errors: errors,
                            });
                          }}
                            checked={child_data.child_lives_with == "father"}
                          >
                            <span>{this.props.t('His father')}</span>
                          </Checkbox>
                          <Checkbox shape="round" color="info" className="checkbox-form" onChange={evt => {
                            child_data.child_lives_with = child_data.child_lives_with == "mother" ? "" : "mother";
                            children_data[idx] = child_data;
                            errors[child_data.key].child_lives_with = "";
                            this.setState({
                              child_data: child_data,
                              errors: errors,
                            });
                          }}
                            checked={child_data.child_lives_with == "mother"}
                          >
                            <span>{this.props.t('His mother')}</span>
                          </Checkbox>
                          <Checkbox shape="round" color="info" className="checkbox-form" onChange={evt => {
                            child_data.child_lives_with = child_data.child_lives_with == "other" ? "" : "other";
                            children_data[idx] = child_data;
                            errors[child_data.key].child_lives_with = "";
                            this.setState({
                              child_data: child_data,
                              errors: errors,
                            });
                          }}
                            checked={child_data.child_lives_with == "other"}
                          >
                            <span>{this.props.t('Other person')}</span>
                          </Checkbox>
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("Number of brothers")}</label>
                        <input type="number" value={child_data.nbr_brothers} placeholder={this.props.t("Number of brothers")} onChange={evt => {
                          child_data.nbr_brothers = evt.target.value;
                          children_data[idx] = child_data;
                          errors[child_data.key].nbr_brothers = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].nbr_brothers}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("Number of sisters")}</label>
                        <input type="number" value={child_data.nbr_sisters} placeholder={this.props.t("Number of sisters")} onChange={evt => {
                          child_data.nbr_sisters = evt.target.value;
                          children_data[idx] = child_data;
                          errors[child_data.key].nbr_sisters = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].nbr_sisters}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("Position dans la fratrie")}</label>
                        <input type="number" value={child_data.position_in_brothers} placeholder={this.props.t("Position dans la fratrie")} onChange={evt => {
                          child_data.position_in_brothers = evt.target.value;
                          children_data[idx] = child_data;
                          errors[child_data.key].position_in_brothers = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].position_in_brothers}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("Mother longue")}</label>
                        <input type="text" value={child_data.first_language} placeholder={this.props.t("Mother longue")} onChange={evt => {
                          child_data.first_language = evt.target.value;
                          children_data[idx] = child_data;
                          errors[child_data.key].first_language = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].first_language}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("2nd language")}</label>
                        <input type="text" value={child_data.second_language} placeholder={this.props.t("2nd language")} onChange={evt => {
                          child_data.second_language = evt.target.value;
                          children_data[idx] = child_data;
                          errors[child_data.key].second_language = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].second_language}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-6 col-12">
                      <div className="field">
                        <label>{this.props.t("Other languages")}</label>
                        <input type="text" value={child_data.other_languages} placeholder={this.props.t("Other languages")} onChange={evt => {
                          child_data.other_languages = evt.target.value;
                          children_data[idx] = child_data;
                          errors[child_data.key].other_languages = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].other_languages}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-12 col-12">
                      <div className="field">
                        <label>{this.props.t("Special diet")}</label>
                        <input type="text" value={child_data.special_diet} placeholder={this.props.t("Special diet")} onChange={evt => {
                          child_data.special_diet = evt.target.value;
                          children_data[idx] = child_data;
                          errors[child_data.key].special_diet = "";
                          this.setState({
                            child_data: child_data,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors[child_data.key].special_diet}
                        </div>
                      </div>
                    </div>
                    <div className="col col-md-12 col-12">
                      <div className="field">
                        <label>{this.props.t("I authorize my child to participate in external sports activities")}</label>
                        <Checkbox shape="curve" color="info" className="checkbox-form d_f"
                          onChange={(evt) => {
                            child_data.parent_authorizes_child_to_participate_to_external_activities = !child_data.parent_authorizes_child_to_participate_to_external_activities;
                            children_data[idx] = child_data;
                            errors[child_data.key].parent_authorizes_child_to_participate_to_external_activities = "";
                            this.setState({
                              child_data: child_data,
                              errors: errors,
                            });
                          }}
                          checked={child_data.parent_authorizes_child_to_participate_to_external_activities}
                        >
                          {this.props.t("I authorize my child to participate in external sports activities")}
                        </Checkbox>
                      </div>
                    </div>
                    <div className="col col-md-12 col-12">
                      <div className="field">
                        <label>{this.props.t("I authorize the staff of the establishment and the stakeholders who work to capture and / or use the image of the child's name within the framework of the school and the activities or educational projects carried out within the school or during the outings which it are associated")}</label>
                        <Checkbox shape="curve" color="info" className="checkbox-form d_f"
                          onChange={(evt) => {
                            child_data.parent_authorizes_school_take_student_photo = !child_data.parent_authorizes_school_take_student_photo;
                            children_data[idx] = child_data;
                            errors[child_data.key].parent_authorizes_school_take_student_photo = "";
                            this.setState({
                              child_data: child_data,
                              errors: errors,
                            });
                          }}
                          checked={child_data.parent_authorizes_school_take_student_photo}
                        >
                          {this.props.t("I authorize the staff of the establishment and the stakeholders who work to capture and / or use the image of the child's name within the framework of the school and the activities or educational projects carried out within the school or during the outings which it are associated")}
                        </Checkbox>
                      </div>
                    </div>
                    <div className="col col-md-12 col-12">
                      <div className="field">
                        <label>{this.props.t("Disseminate these images on the media used by the establishment (Exhibitions, website, videos, etc.)")}</label>
                        <Checkbox shape="curve" color="info" className="checkbox-form d_f"
                          onChange={(evt) => {
                            child_data.parent_authorizes_school_to_broadcast_student_photo = !child_data.parent_authorizes_school_to_broadcast_student_photo;
                            children_data[idx] = child_data;
                            errors[child_data.key].parent_authorizes_school_to_broadcast_student_photo = "";
                            this.setState({
                              child_data: child_data,
                              errors: errors,
                            });
                          }}
                          checked={child_data.parent_authorizes_school_to_broadcast_student_photo}
                        >
                          {this.props.t("Disseminate these images on the media used by the establishment (Exhibitions, website, videos, etc.)")}
                        </Checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          })}
          
          {["format_2", "format_3", "format_5", "format_6"].indexOf(this.inscription_format) !== -1 && 
            <div className="row add_inscription">
              <div className="col-12">
                <div className={"actions " + (children_data.length > 1 ? "styled" : "")}>
                  <div class="addChild" onClick={(evt) => {
                    var last_child_data = this.state.children_data[this.state.children_data.length - 1] || {};
                    children_data.push({
                      key: parseInt(Math.random() * 10000),
                      last_name: "",
                      first_name: "",
                      last_name_ar: "",
                      first_name_ar: "",
                      responsable_last_name: this.transformText(this.save_names_in_uppercase_in_preinscription, last_child_data.responsable_last_name || ""),
                      responsable_first_name: this.transformText(this.save_names_in_uppercase_in_preinscription, last_child_data.responsable_first_name || ""),
                      responsable2_last_name: this.transformText(this.save_names_in_uppercase_in_preinscription, last_child_data.responsable2_last_name || ""),
                      responsable2_first_name: this.transformText(this.save_names_in_uppercase_in_preinscription, last_child_data.responsable2_first_name || ""),
                      responsable_last_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, last_child_data.responsable_last_name_ar || ""),
                      responsable_first_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, last_child_data.responsable_first_name_ar || ""),
                      responsable2_last_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, last_child_data.responsable2_last_name_ar || ""),
                      responsable2_first_name_ar: this.transformText(this.save_names_in_uppercase_in_preinscription, last_child_data.responsable2_first_name_ar || ""),
                      level_id: "",
                      level_group_id: "",
                      gsm_1: last_child_data.gsm_1 || "",
                      gsm_1_2: last_child_data.gsm_1_2 || "",
                      gsm_2: last_child_data.gsm_2 || "",
                      birthday1: last_child_data.birthday1 || null,
                      birthday2: last_child_data.birthday2 || null,
                      company1: last_child_data.company1 || "",
                      company2: last_child_data.company2 || "",
                      birthday: null,
                      birth_place: "",
                      actual_school: "",
                      bulletin_link: "",
                      address: last_child_data.address || "",
                      email: last_child_data.email || "",
                      email2: last_child_data.email2 || "",
                      blood_group: "",
                      child_doctor_address: "",
                      child_doctor_first_name: "",
                      child_doctor_last_name: "",
                      child_doctor_phone: "",
                      child_lives_with: "",
                      first_language: "",
                      second_language: "",
                      other_languages: "",
                      special_diet: "",
                      emergency_contact: "",
                      emergency_contact_address: "",
                      emergency_contact_first_name: "",
                      emergency_contact_last_name: "",
                      emergency_contact_phone: "",
                      insc_child_nationality: "",
                      last_classe_attended: "",
                      redoublant: false,
                      parent_authorizes_child_to_participate_to_external_activities: false,
                      parent_authorizes_school_take_student_photo: false,
                      parent_authorizes_school_to_broadcast_student_photo: false,
                      nbr_brothers: last_child_data.nbr_brothers || 0,
                      nbr_sisters: last_child_data.nbr_sisters || 0,
                      position_in_brothers: (last_child_data.position_in_brothers || 0) + 1,
                      nationality1: last_child_data.nationality1 || "",
                      nationality2: last_child_data.nationality2 || "",
                      work_place1: last_child_data.work_place1 || "",
                      work_place2: last_child_data.work_place2 || "",
                      cin_father: last_child_data.cin_father || "",
                      cin_mother: last_child_data.cin_mother || "",
                      have_a_health_problem: false,
                      gender: "",
                      health_problem: "",
                    });
                    this.setState({
                      children_data: children_data,
                    });
                  }}>+</div>{this.props.t("Ajouter un élève")}
                </div>
              </div>
            </div>
          }
          <div className="action">
            <div className={"btn btn-action " + (is_submitting ? "submitting" : "")} onClick={this.submit}  style={{backgroundColor: (unconnected_inscription_configuration.style || {}).header_bg || "#3eb6ad"}}>
              {this.props.t("Envoyer la demande")}
            </div>
          </div>
        </>
      }
    </div>
  }

  render() {
    const {school_target, school_id_target} = this.state;
    if(this.state.target_school_style == 2){
      let {next_scholar_year, selected_scholar_year, errors, responsable_full_name, responsable_phone, responsable_email, all_schools_targets, is_submitting} = this.state;
      return <DashboardSchoolClientInscriptionStyle2 className={this.state.succession_message ? "bgw" : ""}>
        {this.state.succession_message ?
          <div className={`school_client_inscription4 `}>
            <div className="empty_bordered_div">
            </div>
            <div className="header justify-content-center">
              <div className="col col-12">
                <div className="">
                  <div className="logo">
                    <img src={"https://cdn.koolskools.com/assets/1771512384956_Madina-3-1.png"} />
                  </div>
                  <div className="slugs">
                    <div className="slug slug_1">
                      Votre demande est bien reçue !
                    </div>
                    <div className="slug slug_2">
                      Merci pour l’intérêt porté à Madina Schools
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        :
        <>
          <div className={`school_client_inscription `}>
            <div className="header justify-content-center">
              <div className="col col-12">
                <div className="">
                  <div className="logo">
                    <img src={"https://cdn.koolskools.com/assets/1771512384956_Madina-3-1.png"} />
                  </div>
                  <div className="slugs">
                    <div className="slug slug_1">
                      Bienvenue dans l'univers de Madina Schools
                    </div>
                    <div className="slug slug_2">
                      L'École qui inspire des cœurs conscients et nourrit des esprits solides
                    </div>
                    <div className="slug slug_3">
                      Maternelle – Primaire – Collège Lycée
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`school_client_inscription2 `}>
            <div className="content">
              <h2 className="title">
                {"Les inscriptions sont ouvertes."} <br/>{`Réservez une place pour la rentrée ${((next_scholar_year ? next_scholar_year : selected_scholar_year || {}).name || "").split("/")[0]} !`}
              </h2>
              <div className="form_content2">
                <div className="form_content">
                  <div className="form">
                    <div className="fields">
                      <div className="field">
                        <label>Votre Nom et Prénom</label>
                        <input type="text" value={responsable_full_name} onChange={evt => {
                          errors.responsable_full_name = "";
                          this.setState({
                            responsable_full_name: evt.target.value,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors.responsable_full_name}
                        </div>
                      </div>
                      <div className="field">
                        <label>Votre Numéro de téléphone mobile</label>
                        <input type="text" value={responsable_phone} placeholder="exemple : 0612345678" onChange={evt => {
                          errors.responsable_phone = "";
                          this.setState({
                            responsable_phone: evt.target.value,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors.responsable_phone}
                        </div>
                      </div>
                      <div className="field">
                        <label>Votre Adresse email</label>
                        <input type="email" value={responsable_email} onChange={evt => {
                          errors.responsable_email = "";
                          this.setState({
                            responsable_email: evt.target.value,
                            errors: errors,
                          });
                        }}/>
                        <div className="error">
                          {errors.responsable_email}
                        </div>
                      </div>
                      <div className="field">
                        <label>Site Madina choisi</label>
                        <div className="input_choices">
                          {all_schools_targets.map(st => {
                            return <span key={st.id} onClick={() => {
                              this.setState({
                                school_target: st,
                              });
                            }} style={{cursor: "pointer"}}>
                              <input type="radio" value={st.id} checked={school_target.id == st.id} onChange={evt => {}} />
                              <label style={{cursor: "pointer"}}>{st.name}</label>
                            </span>
                          })}
                        </div>
                      </div>
                      <div className={`button ${is_submitting ? "submitting" : ""}`} onClick={this.submit}>
                        <button>
                          <span>Envoyer</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`school_client_inscription3 `}>
            <div className="footer_content">
              <div className="left_right">
                <div className="left">
                  <div className="content">
                    <p>
                      {`@Madina ${new Date().getFullYear()}. Tous droits réservés.`}
                    </p>
                  </div>
                </div>
                <div className="right">
                  {(school_target && school_target.facebook_url) &&
                    <span className="elementor-grid-item">
                      <a href={school_target.facebook_url} target="_blank" rel="noopener noreferrer">
                        <svg aria-hidden="true" class="e-font-icon-svg e-fab-facebook" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path></svg>
                      </a>
                    </span>
                  }
                  {(school_target && school_target.instagram_url) &&
                    <span className="elementor-grid-item">
                      <a href={school_target.instagram_url} target="_blank" rel="noopener noreferrer">
                        <svg aria-hidden="true" class="e-font-icon-svg e-fab-instagram" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>
                      </a>
                    </span>
                  }
                  {(school_target && school_target.linkedin_url) &&
                    <span className="elementor-grid-item">
                      <a href={school_target.linkedin_url} target="_blank" rel="noopener noreferrer">
                        <svg aria-hidden="true" class="e-font-icon-svg e-fab-linkedin" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path></svg>
                      </a>
                    </span>
                  }
                </div>
              </div>
            </div>
          </div>
        </>
        }
      </DashboardSchoolClientInscriptionStyle2>
    }
    return (
      <DashboardSchoolClientInscriptionStyle>
        {!school_target ?
        <>
          {/* <LoadingAssets /> */}
        </>
        :
          <MediaQuery query="(max-width: 940px)">
            {(matches) =>{
              if(matches){
                return <div className={`school_client_inscription ${matches ? "mobile" : "web"}`}>
                  {!this.params.get('hide_logo') && this.render_header(school_target)}
                  {this.render_body(school_target, true)}
                  <div className="footer">
      
                  </div>
                </div>
              }
              else{
                return <div className={`school_client_inscription ${matches ? "mobile" : "web"}`}>
                  <div className="row justify-content-center">
                    <div className="col col-6">
                      {this.render_body(school_target, false)}
                    </div>
                    {!this.params.get('hide_logo') &&
                    <div className="col col-6">
                      {this.render_header(school_target)}
                    </div>
                    }
                  </div>
                </div>
              }
          }}
          </MediaQuery>
        }
      </DashboardSchoolClientInscriptionStyle>
    );
  }
}

const DashboardSchoolClientInscriptionStyle2 = styled.div`
  min-height: 100vh;
  background: #F3F3F37A;
  &.bgw{
    background: #FFFFFF;
  }
  .school_client_inscription4 {
    min-height: calc(100vh - 160px);
    padding: 0px 0px;
    background-color: #DC5548;
    background-image: none;
    transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
    padding: 0px 0px 50px 0px;
    position: relative;
    overflow: hidden;
    margin-top: 80px;
    margin-bottom: 80px;
    .empty_bordered_div{
      position: absolute;
      right: 0px;
      top: 50%;
      width: 450px;
      height: 450px;
      border: 80px solid #b7c833;
      border-radius: 50%;
      transform: translate(50%, -50%);
    }
    .header{
      max-width: 1140px;
      margin: auto;
      width: 100%;
      padding-bottom: 120px;
      .logo{
        position: relative;
        height: 250px;
        img{
          width: max-content;
          max-width: 200px;
          max-height: 200px;
          left: 50%;
          top: calc(50% - 86px);
          transform: translate(-50%, -50%);
          position: absolute;
          min-width: 200px;
          min-height: 200px;
          max-width: 400px;
          max-height: 250px;
          width: 250px;
          height: 250px;
        }
      }
      .slugs{
        .slug{
          text-align: center;
          font-family: "Montserrat", Sans-serif;
          font-size: 50px;
          font-weight: 700;
          line-height: 75px;
          color: #FFFFFF;
          padding: 0px 18px;
        }
        .slug_2, .slug_3{
          text-align: center;
          font-family: "Montserrat", Sans-serif;
          font-size: 34px;
          font-weight: 600;
          color: #FFFFFF;
          line-height: normal;
          padding: 10px 10px;
        }
      }
    }
    
  }
  .school_client_inscription {
    padding: 0px 0px;
    background-color: transparent;
    background-image: linear-gradient(135deg, #DC5548 28%, #f2295b 100%);
    transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
    padding: 0px 0px 50px 0px;
    position: relative;
    .header{
      max-width: 1140px;
      margin: auto;
      width: 100%;
      padding-bottom: 120px;
      .logo{
        position: relative;
        height: 250px;
        img{
          width: max-content;
          max-width: 200px;
          max-height: 200px;
          left: 50%;
          top: calc(50% - 86px);
          transform: translate(-50%, -50%);
          position: absolute;
          min-width: 200px;
          min-height: 200px;
          max-width: 400px;
          max-height: 250px;
          width: 250px;
          height: 250px;
        }
      }
      .slugs{
        .slug{
          text-align: center;
          font-family: "Montserrat", Sans-serif;
          font-size: 73px;
          font-weight: 700;
          line-height: 75px;
          color: #FFFFFF;
          padding: 15px 18px;
        }
        .slug_2, .slug_3{
          text-align: center;
          font-family: "Montserrat", Sans-serif;
          font-size: 29px;
          font-weight: 600;
          color: #FFFFFF;
          line-height: normal;
          padding: 10px 10px;
        }
      }
    }
    
  }
  .school_client_inscription2{
    background-color: #f9f9f97a;
    background-color: #f7f2f2b5;
    transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 30px 0px 30px 0px;
    position: relative;
    padding-bottom: 80px;
    >div.content{
      max-width: 1240px;
      margin: auto;
      width: 100%;
      display: flex;
      margin-inline: auto;
      position: relative;
      padding-top: 43px;
      flex-wrap: wrap;
      h2.title{
        font-family: "Montserrat", Sans-serif;
        font-size: 29px;
        font-weight: 600;
        line-height: 37px;
        color: #2C2730;
        width: 100%;
        text-align: center;
        margin: 0;
        padding: 0;
      }
      .form_content2{
        background-color: #FFFFFF;
        margin-top: 85px;
        width: 100%;
        padding-bottom: 60px;
      }
      div.form_content{
        padding-top: 60px;
        max-width: 730px;
        display: flex;
        margin-inline: auto;
        position: relative;
        margin: auto;
        .form{
          padding: 10px;
          display: flex;
          align-content: flex-start;
          flex-wrap: wrap;
          position: relative;
          width: 100%;
          div.fields{
            background-color: #FFFFFF;
            padding: 50px 40px 50px 40px;
            border-style: solid;
            border-width: 1px 1px 1px 1px;
            border-color: #DEDEDE;
            border-radius: 20px 20px 20px 20px;
            width: 100%;
            .field{
              padding-right: calc(9px / 2);
              padding-left: calc(9px / 2);
              margin-bottom: 24px;
              width: 100%;
              align-items: center;
              flex-wrap: wrap;
              display: flex;
              min-height: 1px;
              position: relative;
              font-size: 1rem;
              .error{
                color: red;
                font-size: 14px;
              }
              >label{
                padding-bottom: 11px;
                font-family: "Montserrat", Sans-serif;
                font-weight: 600;
                color: #000000;
                cursor: pointer;
                display: inline-block;
                line-height: 1;
                vertical-align: middle;
                &:after{
                  color: red;
                  content: "*";
                  padding-inline-start: .2em;
                }
                .required{
                }
              }
              input:not([type="radio"]){
                background-color: #ffffff;
                font-family: "Montserrat", Sans-serif;
                font-weight: 400;
                color: #8F8F8F;
                flex-basis: 100%;
                max-width: 100%;
                border: 1px solid #69727d;
                flex-grow: 1;
                vertical-align: middle;
                width: 100%;
                border-radius: 3px;
                padding: 0.5rem 1rem;
                transition: all 0.3s;
                font-size: 15px;
                line-height: 1.4;
                min-height: 45px;
                margin: 0;
              }
              .input_choices{
                flex-basis: 100%;
                max-width: 100%;
                display: flex;
                flex-wrap: wrap;
                unicode-bidi: isolate;
                span{
                  flex-basis: 100%;
                  margin: 0;
                  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
                  font-size: 1rem;
                  font-weight: 400;
                  line-height: 1.5;
                  color: #333;
                  background-color: #fff;
                  label{
                    font-family: "Montserrat", Sans-serif;
                    font-weight: 400;
                    color: #000000;
                    display: inline;
                    line-height: 1;
                    vertical-align: middle;
                    cursor: default;
                    font-size: 1rem;
                    background-color: #fff;
                    -webkit-font-smoothing: antialiased;
                  }
                  input{
                    display: inline;
                    padding: 0;
                    font-family: inherit;
                    font-size: 1rem;
                    line-height: 1.5;
                    margin: 0;
                    background-color: initial;
                    cursor: pointer;
                    appearance: auto;
                    border: initial;
                    text-rendering: auto;
                    color: fieldtext;
                    letter-spacing: normal;
                    word-spacing: normal;
                    text-transform: none;
                    text-indent: 0px;
                    text-shadow: none;
                    padding-block: 1px;
                    padding-inline: 2px;
                    margin-right: 5px;
                  }
                }
              }
            }
            .button{
              padding-right: calc(9px / 2);
              padding-left: calc(9px / 2);
              margin-bottom: 24px;
              align-items: flex-end;
              width: 100%;
              display: flex;
              flex-wrap: wrap;
              min-height: 1px;
              position: relative;
              cursor: pointer;
              &.submitting{
                opacity: 0.5;
                cursor: not-allowed;
              }
              button{
                background-color: #000000;
                color: #ffffff;
                font-family: "Montserrat", Sans-serif;
                font-size: 16px;
                font-weight: 700;
                border-radius: 40px 40px 40px 40px;
                padding: 0px 0px 0px 0px;
                flex-basis: 100%;
                min-height: 40px;
                border: none;
                padding-block-end: 0;
                padding-block-start: 0;
                cursor: pointer;
                display: inline-block;
                fill: #fff;
                line-height: 1;
                text-align: center;
                white-space: nowrap;
                user-select: none;
              }
            }
          }
        }
      }
    }
  }
  .school_client_inscription3{
    padding: 25px 0px 0px 0px;
    position: relative;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    background-color: #fff;
    -webkit-font-smoothing: antialiased;
    .footer_content{
      max-width: 1240px;
      margin: auto;
      width: 100%;
      display: flex;
      margin-inline: auto;
      position: relative;
      font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: #333;
      background-color: #fff;
      -webkit-font-smoothing: antialiased;
      .left_right{
        width: 100%;
        padding: 10px;
        display: flex;
        flex-wrap: wrap;
      }
      .left{
        align-content: flex-start;
        flex-wrap: wrap;
        position: relative;
        width: 50%;
        >.content{
          font-family: "Montserrat", Sans-serif;
          font-size: 14px;
          font-weight: 300;
          color: #000000;
          p{
            margin-block-start: 0;
            margin-block-end: .9rem;
            font-family: "Montserrat", Sans-serif;
            font-size: 15px;
            font-weight: 400;
            color: #000000;
          }
        }
      }
      .right{
        display: flex;
        align-content: flex-end;
        flex-wrap: wrap;
        width: 50%;
        text-align: right;
        justify-content: flex-end;
        .elementor-grid-item{
          display: inline-block;
          margin-block-end: 0;
          word-break: break-word;
          min-width: 0;
          margin-left: 10px;
          a{
            background-color: #000000;
            margin: 0;
            font-size: 25px;
            height: calc(25px + 1em);
            line-height: 25px;
            width: calc(25px + 1em);
            border-radius: 50%;
            box-shadow: none;
            text-decoration: none;
            align-items: center;
            cursor: pointer;
            display: inline-flex;
            justify-content: center;
            text-align: center;
            svg{
              fill: #fff;
              display: block;
              height: 1em;
              position: relative;
              width: 1em;
            }
          }
        }
      }
    }
  }
  @media (max-width: 768px) {
    .school_client_inscription{
      padding-bottom: 20px !important;
      .header{
        padding-bottom: 0px !important;
        .logo{
          height: 200px !important;
          img{
            width: 225px !important;
            height: 215px !important;
            top: calc(50% - 60px) !important;
          }
        }
      }
      .slug_1{
        font-size: 32px !important;
        line-height: 37px !important;
        padding-top: 8px !important;

      }
      .slug_2{
        font-size: 19px !important;
        line-height: 22px !important;
      }
      .slug_3{
        font-size: 19px !important;
        line-height: 22px !important;
      }
    }
    .school_client_inscription2{
      padding-bottom: 60px !important;
      >div.content{
        h2.title{
          font-size: 18px !important;
          font-weight: 700 !important;
          line-height: 27px !important;
        }
        div.form_content{
          padding-top: 36px !important;
          .form{
            padding: 10px 30px !important;
            .fields{
              padding: 60px 20px 50px 20px !important;
              .field{
                >label{
                  font-weight: 700 !important;
                }
              }
            }
          }
        }
        div.form_content2{
          padding-bottom: 30px !important;
        }
      }
    }
    .school_client_inscription3{
      .footer_content{
        .left{
          width: 100%;
          .content{
            text-align: center;
            p{
              text-align: center;
              font-size: 13px !important;
              padding-bottom: 25px !important;
            }
          }
        }
        .right{
          width: 100%;
          justify-content: center;
        }
      }
    }
    .school_client_inscription4{
      margin-top: 75px !important;
      margin-bottom: 0px !important;
      .empty_bordered_div{
        width: 350px !important;
        height: 350px !important;
        border: 65px solid #b7c833 !important;
      }
      .header{
        .logo{
          height: 260px !important;
          img{
            top: calc(50% - 75px) !important;
            width: 260px !important;
            width: 220px !important;
            height: 220px !important;
          }
        }
      }
      .slugs{
        margin-top: 15px !important;
        .slug{
          font-size: 37px !important;
          font-weight: 700 !important;
          line-height: 45px !important;
          &.slug_2, &.slug_3{
            font-size: 28px !important;
          }
        }
      }
    }
  }
`;
const DashboardSchoolClientInscriptionStyle = styled.div`
  min-height: 100vh;
  .school_client_inscription {
    padding: 0px 95px;
    background: #f0f0f0;
    *{
      font-family: Lato,sans-serif !important;
    }
    i{
      font-family: FontAwesome !important;
    }
    .header{
      padding: 50px;
      border-radius: 15px 15px 0 0;
      opacity: 72%;
      .row{
        margin-right: -5px;
        margin-left: -5px;
        width: calc(100% - 10px);
        .row2{
          margin-right: 0px;
          margin-left: 0px;
          width: 100%;
        }
        .col2{
          padding: 0;
        }
      }
      .col-contact{
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .logo{
        position: relative;
        img{
          width: max-content;
          max-width: 200px;
          max-height: 200px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          position: absolute;
          min-width: 200px;
          min-height: 200px;
          max-width: 400px;
          max-height: 250px;
        }
      }
      .contact_infos{
        .text{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .text1{
            color: white;
            font-size: 20px;
            font-weight: bold;
            font-size: 1.75rem;
            font-weight: normal;
            padding: 35px;
            padding-bottom: 20px;
          }
          .text2{
            color: white;
            font-size: 15px;
          }
        }
        .info_contacts{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-top: 10px;
          .contact_info{
            color: white;
            font-size: 15px;
            font-weight: bold;
            i{
              margin-right: 5px;
            }
            span{
              width: 100%;
              word-break: break-all;
            }
          }
        }
      }
    }
    .body{
      padding: 20px;
      border-radius: 0 0 15px 15px;
      background: white;
      padding-bottom: 5px;
      .title{
        text-align: center;
        justify-content: center;
        font-weight: bold;
        font-size: 25px;
        margin-bottom: 25px;
        margin-top: 15px;
        padding: 11px;
        padding-top: 25px;
      }
      .succession_message{
        width: 100%;
        min-height: 150px;
        background: #a7f1a7;
        color: green;
        margin-top: 150px;
        border-radius: 15px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        font-weight: bold;
        font-size: 25px;
      }
      .formular{
        .d_flex{
          .radios{
            width: max-content;
            min-width: 200px;
            padding-top: 0;
            margin-left: 0;
            display: inline-block;
            .RadioLegend{
              >span{
                padding: 0;
                float: left;
                input{
                  float: left;
                  width: 100%;
                  height: 28px;
                  border-radius: 2.6px;
                  border: 0.6px solid #d1dbe2;
                  background-color: rgba(245, 248, 249, 0.3);
                  font-size: 14px;
                  font-weight: 400;
                  color: #1b2437 !important;
                  padding-left: 10px;
                  padding-right: 10px;
                }
              }
              legend{
                width: auto;
                float: left;
                display: inline-block;
                border: none;
                margin: 18px 25px 0 0;
                font-size: 12px;
                margin-top: 8px;
                margin-right: 10px;
              }
            }
          }
        }
        .col{
          margin-bottom: 9px;
        }
        .section_div{
          margin-bottom: 25px;
          border: 3px solid #bfbcbc;
          border-radius: 10px;
          position: relative;
          padding-top: 45px;
          margin-top: 25px;
          .title{
            padding: 10px !important;
            width: max-content;
            position: absolute;
            top: 0;
            transform: translateY(-50%);
            margin: 0;
            background: white;
            font-size: 22px;
          }
        }
        .field{
          label{
            display: block;
            font-family: Montserrat;
            font-size: 15px;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1b2437;
            margin-bottom: 5px;
            display: none;
            &.d_b_i{
              display: block;
            }
          }
          input{
            float: left;
            width: 100%;
            height: 55px;
            border-radius: 2.6px;
            border: 0.6px solid #d1dbe2;
            border: 0.6px solid #c7c7c7;
            background-color: rgba(245,248,249,.3);
            background-color: white;
            font-size: 14px;
            font-weight: 400;
            font-weight: normal !important;
            line-height: 1.5;
            color: #1b2437!important;
            color: #b1b1b1 !important;
            color: #646464 !important;
            &:not([type=tel]){
              padding-left: 10px !important;
              padding-right: 10px !important;
            }
            &::placeholder { 
              opacity: 1 !important;
              color: #828282 !important;
              font-weight: 400 !important;
            }
            
            &:-ms-input-placeholder { 
              color: #828282 !important;
              font-weight: 400 !important;
            }
            
            &::-ms-input-placeholder { 
              color: #828282 !important;
              font-weight: 400 !important;
            }
          }
          .intl-tel-input{
            width: 100%;
          }
          .select{
            float: left;
            width: 100%;
            height: 29px;
            height: 59px;
            border-radius: 2.6px;
            border: 0.6px solid #d1dbe2;
            border: 0.6px solid #c7c7c7;
            background-color: rgba(245,248,249,.3);
            background-color: white;
            position: relative;
            padding-left: 3px;
            margin-bottom: 0px;
            select{
              float: left;
              width: 100%;
              font-size: 14px;
              height: 28px;
              border: none;
              outline: none;
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              text-indent: 1px;
              text-overflow: "";
              background: transparent;
              outline: 0;
              position: relative;
              z-index: 9;
              border-radius: 4px!important;
              border: none!important;
              font-weight: normal !important;
              font-family: Montserrat;
              color: #1b2437;
              padding: 0 5px;
              height: 59px;
              color: #828282 !important;
              &.selected{
                color: #646464 !important;
              }
            }
            i{
              color: #d2dbe2;
              font-size: 14px;
              position: absolute;
              right: 5px;
              top: 20px;
            }
            .added_info_level{
              position: absolute;
              color: #9d9d9d;
              top: 100%;
              text-align: right;
              right: 0;
              font-size: 10px;
              color: #b1b1b1 !important;
              padding: 5px 0;
            }
          }
          .react-datepicker-wrapper{
            margin: 0;
          }
          .error{
            color: red;
          }
          .checkbox-form{
            width: 100%;
            height: 55px;
            border: 0.6px solid #c7c7c7;
            padding-left: 5px;
            border-radius: 2.6px;

            position: relative;
            min-height: 55px;
            height: max-content;
            input{

              height: 100%;
              float: left;
              width: 100%;
              border-radius: 2.6px;
              border: 0.6px solid #d1dbe2;
              background-color: rgba(245,248,249,.3);
              font-size: 14px;
              font-weight: 400;
              color: #1b2437!important;
              padding-left: 10px;
              position: absolute;
              left: 0;
              top: 0;
              min-width: 1em;
              z-index: 2;
              opacity: 0;
              margin: 0;
              padding: 0;
              cursor: pointer;
              &:checked ~ .state.p-info label:after{
                transform: translate(2%, -50%) scale(0.6);
                background-color: #51c4bc !important;
              }
            }
            >div{
              label, .label{
                display: block;
                font-family: Montserrat;
                font-size: 15px;
                font-weight: 500;
                font-style: normal;
                font-stretch: normal;
                line-height: 55px;
                letter-spacing: normal;
                color: #1b2437;
                margin-bottom: 5px;
                padding-left: 10px;
                white-space: break-spaces;
                margin: auto;
                line-height: 50px;
                padding-left: 30px;
                text-indent: 0;
                &:before, &:after{
                  top: 50% !important;
                  transform: translateY(-50%);
                  width: 20px;
                  height: 20px;
                  left: 5px;
                }
              }
            }
          }
          .input_choices{
            width: 100%;
            height: 55px;
            border: 0.6px solid #c7c7c7;
            padding-left: 5px;
            border-radius: 2.6px;
            min-height: 55px;
            height: max-content;
            display: flex;
            flex-wrap: wrap;
            .checkbox-form{
              width: 32%;
              border: 0;
              margin-right: 1%;
              min-width: max-content;
              input{
                float: left;
                width: 100%;
                height: 55px;
                border-radius: 2.6px;
                border: 0.6px solid #d1dbe2;
                background-color: rgba(245,248,249,.3);
                font-size: 14px;
                font-weight: 400;
                color: #1b2437!important;
                padding-left: 10px;
                position: absolute;
                left: 0;
                top: 0;
                min-width: 1em;
                z-index: 2;
                opacity: 0;
                margin: 0;
                padding: 0;
                cursor: pointer;

                &:checked ~ .state.p-info label:after{
                  transform: translate(2%, -50%) scale(0.6);
                  background-color: #51c4bc !important;
                }
              }
              >div{
                label, .label{
                  display: block;
                  font-family: Montserrat;
                  font-size: 15px;
                  font-weight: 500;
                  font-style: normal;
                  font-stretch: normal;
                  line-height: 55px;
                  letter-spacing: normal;
                  color: #1b2437;
                  margin-bottom: 5px;
                  padding-left: 30px;
                  &:before, &:after{
                    top: 50% !important;
                    transform: translateY(-50%);
                    width: 20px;
                    height: 20px;
                    left: 5px;
                  }
                }
              }
            }
            &.c_25{
              .checkbox-form{
                width: 24%;
                border: 0;
                margin-right: 1%;
              }
            }
          }
          &.bulletin{
            display: flex;
            label{
              display: block;
              line-height: 30px;
              color: #898787;
              margin-right: 5px;
              margin-bottom: 0;
            }
            >div{
              button{
                position: relative;
                padding: 0 10px;
                min-width: -webkit-max-content;
                min-width: -moz-max-content;
                min-width: max-content;
                font-size: 11px;
                input{
                  cursor: pointer;
                  opacity: 0;
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  top: 0;
                  left: 0;
                }
              }
              &.doc{
                margin: 0;
                width: calc(100% - 130px);
                line-height: 25px;
                .name{
                  width: 100%;
                  text-align: left;
                  display: block;
                }
              }
              &.actions{
                display: flex;
                justify-content: center;
                max-width: 100%;
                button{
                  padding: 2px 5px;
                  width: 20px!important;
                  height: 20px!important;
                  font-size: 12px;
                  line-height: 20px;
                  margin: 5px 5px 0;
                }
                .remove_document{
                  color: red;
                  cursor: pointer;
                  border-radius: 50%;
                  border: 1px solid red;
                  display: block;
                  width: 20px;
                  height: 20px;
                  line-height: 19px;
                  text-align: center;
                  margin: 4px 5px 0;
                }
              }
            }
          }
        }
        &.styled{
          border: 2px solid #56729f;
          border-radius: 10px;
          padding: 18px 0 !important;
          margin-left: 45px;
          margin-right: 45px;
          padding-top: 0;
          position: relative;
          margin-bottom: 15px;
          .child_title{
            position: absolute;
            bottom: 100%;
            transform: translateY(50%);
            background: white;
            padding: 5px;
            font-weight: bold;
            left: 8px;
          }
          .removeChild{
            display: inline-block;
            width: 22px;
            height: 22px;
            border-radius: 15px;
            box-shadow: #f7090945 0px 18px 36px 0px;
            background-image: linear-gradient(225deg, #f52b2b, #f36464);
            font-size: 16px;
            font-weight: bold;
            text-align: center;
            line-height: 22px;
            color: rgb(255, 255, 255);
            cursor: pointer;
            position: absolute;
            left: 100%;
            bottom: 100%;
            transform: translate(-50%, 50%);
            margin: 0;
          }
        }
      }
      .action{
        text-align: center;
        margin-top: 20px;
        .btn-action{
          width: 100%;
          border-radius: 6px;
          padding: 16px 0px 14px;
          color: #FFF;
          font-family: 'Inter', sans-serif !important;
          font-weight: bold;
          font-size: 15px;
          text-transform: uppercase;
          &.submitting{
            opacity: 0.5;
            cursor: not-allowed;
          }
        }
      }
    }
    .footer{

    }
    &.web{
      min-height: 100vh;
      padding: 60px 95px;
      >.row{
        height: 100%;
        >.col{
          padding: 0;
        }
        .body{
          height: 100%;
          padding-bottom: 40px;
          border-radius: 15px 0 0 15px;
          .title{
            font-size: 28px;
            padding-top: 41px;
          }
          .formular{
            padding: 18px 50px;
            .select{
              height: 55px;
              margin-bottom: 10px;
            }
          }
          .action{
            padding: 0 48px;
          }
        }
        .header{
          height: 100%;
          padding-top: 150px;
          border-radius: 0 15px 15px 0;
          .logo{
            margin: auto;
            min-width: 200px;
            min-height: 200px;
          }
          .text{
            text-align: center;
          }
          .info_contacts{
            text-align: center;
          }
        }
      }
    }
  }
  .add_inscription{
    margin: 10px auto;
    .actions{
      display: flex;
      justify-content: left;
      max-width: 100%;
      padding: 0px 30px;
      max-width: 100%;
      line-height: 10px;
      font-weight: bold;
      &.styled{
        padding: 0px 30px;
      }
      .addChild{
        display: inline-block;
        width: 30px;
        height: 30px;
        border-radius: 15px;
        box-shadow: 0 18px 36px 0 #efc25b80;
        background-image: -webkit-linear-gradient(225deg,#fdd271,#d5a433);
        background-image: linear-gradient(225deg,#fdd271,#d5a433);
        font-size: 16px;
        text-align: center;
        line-height: 30px;
        font-weight: 700;
        color: #fff;
        margin-top: -10px;
        margin-left: 10px;
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
  @media (max-width: 1199px) {
    .school_client_inscription {
      padding: 0px 26px;
      .header{
        .row{
          margin: 0;
        }
        .contact_infos{
          .text{
            .text1{
              font-size: 15px;
              font-size: 1.75rem;
              padding: 35px;
              padding-bottom: 20px;
            }
            .text2{
              font-size: 11px;
              font-size: 1rem;
            }
          }
          .info_contacts{
            .contact_info{
              font-size: 11px;
              font-size: 1rem;
            }
          }
        }
      }
      .body{
        .formular{
          padding: 18px 0px !important;
          .col-md-6{
            flex: 0 0 100%;
            max-width: 100%;
          }
        }

        .action{
          padding: 0 0px !important;
        }
      }
    }
    .formular{
      &.styled{
        margin-left: 0 !important;
        margin-right: 0 !important;
      }
    }
    .add_inscription{
      .actions{
        padding: 0px 0px !important;
        margin-left: -15px !important;
        &.styled{
          padding: 0px 0px !important;
          margin-left: -15px !important;
        }
      }
    }
  }
  @media (max-width: 939.99px) {
    .school_client_inscription {
      padding: 0px 26px;
      .header{
        .row{
          margin: 0;
        }
        .contact_infos{
          .text{
            .text1{
              font-size: 15px;
              font-size: 1.75rem;
              padding: 35px;
              padding-bottom: 20px;
            }
            .text2{
              font-size: 11px;
              font-size: 1rem;
            }
          }
          .info_contacts{
            .contact_info{
              font-size: 11px;
              font-size: 1rem;
            }
          }
        }
      }
      &.mobile{
        padding: 0px 0px;
        .header{
          height: 360px;
          padding: 20px;
          padding-top: 20px;
          border-radius: 0;
          .row{
            margin: 0;
          }
          .logo{
            min-width: 200px !important;
            min-height: 150px !important;
            margin: auto;
            margin-bottom: 15px;
            text-align: center;
            position: relative;
            img{
              max-width: 100%;
              max-height: 100%;
              min-width: 200px !important;
              min-height: 150px !important;
              width: unset;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }
          .contact_infos{
            .text{
              text-align: center;
              .text1{
                padding: 35px;
                padding-bottom: 10px;
                padding-top: 0;
                padding: 0;
              }
              .text2{
              }
            }
            .info_contacts{
              text-align: center;
              .contact_info{
                i{
                }
                span{
                }
              }
            }
          }
        }
        .body{
          .succession_message{
            margin-top: 100px;
          }

          .action{
            padding: 0 0px;
          }
        }
        .footer{
    
        }
      }
    }
  }
  @media (max-width: 768px) {
    .school_client_inscription {
      padding: 0px 26px;
      .header{
        height: 360px;
        padding: 20px;
        padding-top: 20px;
        .row{
          margin: 0;
        }
        .logo{
          min-width: 200px !important;
          min-height: 150px !important;
          margin: auto;
          margin-bottom: 15px;
          text-align: center;
          img{
            max-width: 100%;
            max-height: 100%;
            min-width: 200px !important;
            min-height: 150px !important;
            width: unset;
            padding: 0;
          }
        }
        .contact_infos{
          .text{
            text-align: center;
            .text1{
              padding: 35px;
              padding-bottom: 10px;
              padding-top: 0;
            }
            .text2{
            }
          }
          .info_contacts{
            text-align: center;
            .contact_info{
              i{
              }
              span{
              }
            }
          }
        }
      }
      .body{
        .succession_message{
          margin-top: 100px;
        }
      }
      .footer{
  
      }
    }
  }
`;

export default withTranslation('translations')(DashboardSchoolClientInscription);
